import React, { useEffect, useRef, useState } from "react";

import { Input, Button, Image, Table, Select, Modal, DatePicker, message, Checkbox, QRCode, TimePicker } from "antd";
import Headers from "./frame/headers.component";
import SockJS from "sockjs-client";
import Stomp from "stompjs";
import AuthService from "../services/auth.service";
import { API_BASE_URL } from "../services/apiConfig";
import {API_BASE_URL_ISSUER} from "../services/apiConfig";
import moment from "moment";
import dayjs from "dayjs";
import { ConsoleSqlOutlined, MinusOutlined, PlusOutlined } from "@ant-design/icons";
import html2canvas from 'html2canvas';
import { FaRegStar, FaStar } from "react-icons/fa";
import { EditOutlined, DeleteOutlined, ExclamationCircleOutlined } from '@ant-design/icons';

interface ClubInfo {
    club_seq: number;
    club_name: string;
    valid: boolean;
    club_category_seq: number;
    agentSeq: number;

}
interface Question {
    name: string;
    input: { [key: string]: string | boolean }[]; // 답변 배열
    type: 'single' | 'multi' | 'input'; // 선택 모드
}
interface ReceptionWaitListView {
    SelectValue: string;
    selectedClubInfo: ClubInfo | null;
    selectmemberidsoket: any;
    onselectedDeviceNameChange: (selectedDeviceName: any) => void;
    onselectchangeupdate: (selectchangeroom: any) => void;
    profiledata: any;
    onselectedDeviceall: (selectdeviceall: String) => void;
}
//접수 + 대기
const ReceptionWaitListView: React.FC<ReceptionWaitListView> = ({ SelectValue, selectedClubInfo, selectmemberidsoket, onselectedDeviceNameChange, profiledata, onselectchangeupdate, onselectedDeviceall }) => {
    const [agentsettingdeviceName, setagentsettingdeviceName] = useState<any>([]);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [newSymptomInput, setNewSymptomInput] = useState(''); // State variable for symptom input
    const [newRoomInput, setNewRoomInput] = useState(''); // State variable for room input
    const [newanswerInput, setNewanswerInput] = useState(''); // State variable for room input
    const [userSymptoms, setUserSymptoms] = useState<any[]>([]);
    const [userRooms, setUserRooms] = useState<any[]>([]);

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isModalVisible2, setIsModalVisible2] = useState(false);
    const [familyInfo, setFamilyInfo] = useState([
        { relationship: "", name: "", gender: "", birthdate: "", chartNumber: "" },
    ]);
    const [selectclubMemberSeq, setselectclubMemberSeq] = useState<number>(0);
    const [birthdate, setBirthdate] = useState<string | null>(null);
    const [lastdate, setlastdate] = useState<dayjs.Dayjs | null>(null); // Dayjs 형식으로 상태 정의
    const { Option } = Select;
    const [waitmodalOpen, setwaitModalOpen] = useState(false);
    const [PQrmodalOpen, setPQrModalOpen] = useState(false);
    const [QQrmodalOpen, setQQrModalOpen] = useState(false);
    const [qrprintmodalOpen, setqrprintmodalOpen] = useState(false);
    const [waitmembermodalOpen, setwaitmemberModalOpen] = useState(false);
    const [selecteagentSetting, setselecteagentSetting] = useState<any[]>([]);
    const [iswaitModallocalname_emp, setiswaitModallocalname_emp] = useState(false);
    const [isselectmember, setisselectmember] = useState(false);
    const [iswaitMemberModallocalname_emp, setiswaitMemberModallocalname_emp] = useState(false);
    const [selectdeviceid, setselectdeviceid] = useState("");
    const [selectwaitmemberModalname, setselectwaitmemberModalname] = useState("");
    const [selectwaitModalname, setselectwaitModalname] = useState("");
    const [selectwaitModallocalname, setselectwaitModallocalname] = useState("");
    const [selectwaitModalphonenumber, setselectwaitModalphonenumber] = useState("");
    const [selectwaitmemberModal, setselectwaitmemberModal] = useState<any[]>([]);
    const [selectwaitModal, setselectwaitModal] = useState<any[]>([]);
    const [agentsettingalldata, setagentsettingalldata] = useState<any>([]);
    const [newwaitlocalname, setnewwaitlocalname] = useState("");
    const [waitinputjuminNumber, setwaitinputjuminNumber] = useState("");
    const [memberwaitlocalname, setmemberwaitlocalname] = useState("");
    const [selectfamilymodalphonenumber, setselectfamilymodalphonenumber] = useState("");
    const [selectfamilymodalname, setselectfamilymodalname] = useState("");
    const [editedPanel, setEditedPanel] = useState(null);
    const [selectformdeviceID, setselectformdeviceID] = useState("");
    const [selectformdeviceName, setselectformdeviceName] = useState("");
    const [expandedDevice, setExpandedDevice] = useState(null);
    const [firstElement, setfirstElement] = useState("");
    const [secondElement, setsecondElement] = useState("");
    const [thirdElement, setthirdElement] = useState("");
    const [fourthElement, setfourthElement] = useState("");
    const [width, setWidth] = useState(window.innerWidth);
    const [newwaitname, setnewwaitname] = useState("");
    const [Qrlasttime, setQrlasttime] = useState('');
    const [Qrlasttimetime, setQrlasttimetime] = useState('');
    const [newqrdevice, setnewqrdevice] = useState("");
    const [memberwaitname, setmemberwaitname] = useState("");
    const [selectholderid, setselectholderid] = useState("");
    const [selectclubviled, setselectclubviled] = useState(false);
    const [selectqrdevicename, setselectqrdevicename] = useState("");
    const [stompClient, setStompClient] = useState<Stomp.Client | null>(null);
    const [JuminnumberstompClient, setJuminnumberstompClient] = useState<Stomp.Client | null>(null);
    const [selectdid, setselectdid] = useState<string>("");
    const [tableData, setTableData] = useState<any[]>([]);
    const [waitingrowdata, setwaitingrowdata] = useState<any[]>([]);
    const [webagentsettingrowdata, setwebagentsettingrowdata] = useState<any[]>([]);
    const [webagentsettingrowdataform, setwebagentsettingrowdataform] = useState<any[]>([]);
    const [waitingdata, setwaitingdata] = useState<any[]>([]);
    const [waitingdata1, setwaitingdata1] = useState<any[]>([]);
    const [waitingrowdata1, setwaitingrowdata1] = useState<any[]>([]);
    const [beforreceiptcount, setbeforreceiptcount] = useState<number>(0);
    const [display, setdisplay] = useState<string | null>(null);
    const [display1, setdisplay1] = useState<string | null>(null);
    const [display2, setdisplay2] = useState<string | null>(null);
    const [display3, setdisplay3] = useState<string | null>(null);
    const [totalWaitcount1, settotalWaitcount1] = useState<number>(0);
    const [waittingdataArray1, setwaittingdataArray1] = useState<any[]>([]);
    const [waittingdataArray2, setwaittingdataArray2] = useState<any[]>([]);
    const [waittingdataArray3, setwaittingdataArray3] = useState<any[]>([]);
    const [contentLength, setcontentLength] = useState<string>("");
    const [waitdataArray, setwaitdataArray] = useState<any[]>([]);
    const [waitdataArray2, setwaitdataArray2] = useState<any[]>([]);
    const [beforreceiptcount1, setbeforreceiptcount1] = useState<number>(0);
    const { TextArea } = Input;
    const [count, setCount] = useState(0);
    const [token, settoken] = useState<string | null>(null);
    const [selectroom, setselectroom] = useState<any[]>([]);
    const [selectrooms, setselectrooms] = useState<any[]>([]);
    const [waitModalselectvalue, setwaitModalselectvalue] = useState<any>([]);
    const [waitfamilyModalselectvalue, setwaitfamilyModalselectvalue] = useState<any>([]);
    const [rooms, setRooms] = useState<string[]>([]);
    const [isOn, setIsOn] = useState(false);
    const [isRotating, setIsRotating] = useState(false);
    const [waitingtabledataArray1, setwaitingtabledataArray1] = useState<any[]>(
        []
    );
    const [waitingtabledataArray2, setwaitingtabledataArray2] = useState<any[]>(
        []
    );
    const [waitingtabledataArray3, setwaitingtabledataArray3] = useState<any[]>(
        []
    );
    const [selectedRowKey, setSelectedRowKey] = useState<string | number | null>(
        null
    );
    const [selectedDeviceName, setSelectedDeviceName] = useState<string>("");
    const [selectmemberid, setselectmemberid] = useState<string>("");
    const [qrdata, setqrdata] = useState<any>("");
    const [qrLinkSeq, setqrLinkSeq] = useState<any>("");
    const [SelectHeaderValue, setSelectHeaderValue] = useState<string | null>(
        null
    );
    const [selectionModes, setSelectionModes] = useState<Array<'single' | 'multi' | 'input'>>(['single']);

    const [typeselectionMode, settypeSelectionMode] = useState<'type1' | 'type2'>('type1');
    const [selectedItems, setSelectedItems] = useState<number[]>([]);
    const [typeselectedItems, settypeSelectedItems] = useState<number[]>([]);
    const [cookievalue, setcookievalue] = useState<any>("");
    const [newquestionInput, setNewquestionInput] = useState('');
    const [newQuestion, setNewQuestion] = useState<string>('');
    const [etcAnswers, setEtcAnswers] = useState<string[]>([]);
    const [answers, setAnswers] = useState<string[][]>([[]]);
    const [type, setType] = useState<string[]>(['single']);
    const [questions, setQuestions] = useState<string[]>(['']);
    const [selectmethodvalue, setSelectMethodValue] = useState('');

    useEffect(() => {
        if (token !== null) {

            setSelectHeaderValue(SelectValue);

        }
    }, [SelectValue]);

    useEffect(() => {
        const cookies = document.cookie.split(';').map(cookie => cookie.trim());
        const myCookie = cookies.find(cookie => cookie.startsWith('myKey='));
        let myValue = "";
        console.log("쿠키여부 : " + myCookie);

        if (myCookie) {
            myValue = myCookie.split('=')[1];
            console.log("저장된 값:", myValue);
            selectedDeviceNameRef.current = myValue;
            setcookievalue(myValue)
            setSelectedDeviceName(myValue);
        }
    }, []);


    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth);
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    useEffect(() => {
        const rawToken = AuthService.getRawToken();
        settoken(rawToken);
    }, []);

    useEffect(() => {
        // if (token !== null && profiledata.length > 0) {
        const profileData = profiledata[0];
        setselectdid(profileData.memberDid);
        setselectmemberid(profileData.memberId);
        // }
    }, [profiledata]);
    useEffect(() => {

        if (token !== null && selectedClubInfo?.club_seq !== 0) {
            fetchwaitagentSettingDataAPI();
            fetchWebAgentSettinglist();
        }

    }, [token, selectedClubInfo?.club_seq]);

    const fetchwaitagentSettingDataAPI = async () => {
        if (token !== null && selectedClubInfo?.club_seq !== 0) {

            try {

                console.log(`${API_BASE_URL_ISSUER}/agentsetting/list/${selectedClubInfo?.club_seq}`)
                const response = await fetch(
                    `${API_BASE_URL_ISSUER}/agentsetting/list/${selectedClubInfo?.club_seq}`,
                    {
                        method: "GET",

                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );
                const data = await response.json();
                console.log("data json : " + JSON.stringify(data.data, null, 2))

                const agentSettingList = data.data.agentSettingList.filter((agentSetting: any) => !agentSetting.deviceId.startsWith("form")).sort((a: any, b: any) => {
                    return new Date(b.updated).getTime() - new Date(a.updated).getTime();
                });
                const deviceNames = agentSettingList.map((agentSetting: any) => agentSetting.deviceName);
                console.log("업데이트되는 디바이스네임 : " + JSON.stringify(deviceNames, null, 2))
                // console.log("agentsetting 총 값 :" + JSON.stringify(agentSettingList, null, 2))
                // console.log("select에 넣을 데이터 : " + deviceNames)
                // console.log("첫번째값 : " + deviceNames[0])

                const selectedValue = deviceNames[0];
                // console.log("Selected value:  ", selectedValue);
                // console.log("전체agentsetting 데이터  : " + JSON.stringify(agentSettingList, null, 2))

                setagentsettingalldata([agentSettingList])
                onselectedDeviceall(JSON.stringify(agentSettingList));
                setagentsettingdeviceName(deviceNames);





            } catch (error) {
                console.error("(ExcelUpload) Error fetching data:", error);
            }
        }
    };


    useEffect(() => {

        if (agentsettingdeviceName.length > 0) {
            const foundDevice = agentsettingdeviceName.find((device: any) => device === cookievalue);
            if (foundDevice) {
                onselectedDeviceNameChange(cookievalue);
            } else {
                onselectedDeviceNameChange(agentsettingdeviceName[0]);
            }
        }

        // console.log("전체agentsetting 데이터  : " + JSON.stringify(agentsettingalldata, null, 2))
        const filterDataByDeviceName = (data: any, selectedValue: any) => {
            const filteredData = [];
            for (const list of data) {
                for (const item of list) {
                    if (item.deviceName === selectedValue) {
                        filteredData.push(item);
                    }
                }
            }

            return filteredData;
        };
        let filteredData: any[] = [];




        if (agentsettingdeviceName.length > 0) {
            const foundDevice = agentsettingdeviceName.find((device: any) => device === cookievalue);
            if (foundDevice) {
                filteredData = filterDataByDeviceName(agentsettingalldata, cookievalue);
            } else {
                filteredData = filterDataByDeviceName(agentsettingalldata, agentsettingdeviceName[0]);
            }
        }


        setselecteagentSetting(filteredData);


        if (agentsettingdeviceName.length > 0) {
            const foundDevice = agentsettingdeviceName.find((device: any) => device === cookievalue);
            if (foundDevice) {
                setSelectedDeviceName(cookievalue);
            } else {
                setSelectedDeviceName(agentsettingdeviceName[0]);
            }
        }

    }, [agentsettingdeviceName]);

    const selectedDeviceNameRef = useRef(selectedDeviceName);
    useEffect(() => {
        selectedDeviceNameRef.current = selectedDeviceName;
        // console.log("selectedDeviceName-> selectedDeviceNameRef : " + selectedDeviceName)
    }, [selectedDeviceName]);






    const selectedClubInfoRef = useRef(selectedClubInfo);
    useEffect(() => {
        selectedClubInfoRef.current = selectedClubInfo;
        // console.log("selectedClubInfo-> selectedClubInfo : " + selectedClubInfo)
    }, [selectedClubInfo]);

    useEffect(() => {
        // console.log("선택한클럽정보 : " + JSON.stringify(selectedClubInfo,null,2))
        // console.log("선택한 진료과의 통합정보@@@@ : " + JSON.stringify(selecteagentSetting,null,2)) 
        if (selecteagentSetting.length !== 0) {
            const agentSettings = selecteagentSetting.map((item) => JSON.parse(item.agentSetting));

            agentSettings.forEach((agentSetting) => {
                if (agentSetting.증상 && agentSetting.진료실) {
                    const symptoms = agentSetting.증상.map((symptom: any) => Object.keys(symptom)[0]);
                    const treatmentRooms = agentSetting.진료실.map((room: any) => Object.keys(room)[0]);

                    // console.log("증상 정보:", symptoms);
                    // console.log("진료실 정보:", treatmentRooms);

                    setselectroom(treatmentRooms);
                }
            });
        }
    }, [selecteagentSetting, selectedClubInfo, waitingdata]);

    useEffect(() => {
        setwaitingtabledataArray1([]);
        setwaitingtabledataArray2([]);
        setwaitingtabledataArray3([]);
        setwaittingdataArray1([]);
        setwaittingdataArray2([]);
        setwaittingdataArray3([]);
        setdisplay1(null);
        setdisplay2(null);
        setdisplay3(null);

        const totalRooms = selectroom.length;
        const rotations = Math.ceil(totalRooms / 3);
        let currentRotation = 0;
        fetchWaitinglistDataAPII();
        const startIndex = currentRotation * 3;
        const endIndex = Math.min(startIndex + 3, totalRooms);
        // console.log("룸스 : " + JSON.stringify(selectroom);
        const roomBatch = selectroom.slice(startIndex, endIndex).join(",");
        // console.log("룸배치 : " + roomBatch);
        if (roomBatch !== "") {
            setdisplay(roomBatch);
            setdisplay1(roomBatch ? roomBatch.split(",")[0] : "");
            setdisplay2(roomBatch && roomBatch.split(",")[1] ? roomBatch.split(",")[1] : "");
            setdisplay3(roomBatch && roomBatch.split(",")[2] ? roomBatch.split(",")[2] : "");
        }
        const displayparam1 = roomBatch ? roomBatch.split(",")[0] : "";
        const displayparam2 = roomBatch && roomBatch.split(",")[1] ? roomBatch.split(",")[1] : "";
        const displayparam3 = roomBatch && roomBatch.split(",")[2] ? roomBatch.split(",")[2] : "";
        currentRotation = (currentRotation + 1) % rotations;
        // fetchWaitMemberviewDataAPI(displayparam1, displayparam2, displayparam3);



    }, [selectedClubInfo?.club_seq]);


    useEffect(() => {
        if (token !== null) {
            setwaitingtabledataArray1([]);
            setwaitingtabledataArray2([]);
            setwaitingtabledataArray3([]);

            // console.log("선택한 룸들 :" + selectroom)
            let timerId: NodeJS.Timeout | null = null;
            const totalRooms = selectroom.length;
            const rotations = Math.ceil(totalRooms / 3);
            let currentRotation = 0;

            const startIndex = currentRotation * 3;
            const endIndex = Math.min(startIndex + 3, totalRooms);
            const roomBatch = selectroom.slice(startIndex, endIndex).join(",");

            if (roomBatch !== "") {
                setdisplay(roomBatch);
                setdisplay1(roomBatch ? roomBatch.split(",")[0] : "");
                setdisplay2(roomBatch && roomBatch.split(",")[1] ? roomBatch.split(",")[1] : "");
                setdisplay3(roomBatch && roomBatch.split(",")[2] ? roomBatch.split(",")[2] : "");
                const displayparam1 = roomBatch ? roomBatch.split(",")[0] : "";
                const displayparam2 = roomBatch && roomBatch.split(",")[1] ? roomBatch.split(",")[1] : "";
                const displayparam3 = roomBatch && roomBatch.split(",")[2] ? roomBatch.split(",")[2] : "";
                fetchWaitMemberviewDataAPI(displayparam1, displayparam2, displayparam3);
                currentRotation = (currentRotation + 1) % rotations;
            } else {
                fetchWaitMemberviewDataAPI("", "", "");
            }

            setselectrooms(["진료실선택", ...selectroom]);

        }

    }, [selectroom]);

    useEffect(() => {
        if (token !== null) {
            // console.log("진료과변경")
            // console.log("(ExcelUpload) 지금 선택중인 진료과 : " + selectedDeviceNameRef.current)
            const totalRooms = selectroom.length;
            const rotations = Math.ceil(totalRooms / 3);

            let currentRotation = 0;

            fetchWaitinglistDataAPII();
            setwaitingtabledataArray1([]);
            setwaitingtabledataArray2([]);
            setwaitingtabledataArray3([]);
            setwaittingdataArray1([]);
            setwaittingdataArray2([]);
            setwaittingdataArray3([]);

            setdisplay1(null);
            setdisplay2(null);
            setdisplay3(null);

            const startIndex = currentRotation * 3;
            const endIndex = Math.min(startIndex + 3, totalRooms);

            const roomBatch = selectroom.slice(startIndex, endIndex).join(",");
            if (roomBatch !== "") {
                setdisplay(roomBatch);

                setdisplay1(roomBatch ? roomBatch.split(",")[0] : "");
                setdisplay2(
                    roomBatch && roomBatch.split(",")[1]
                        ? roomBatch.split(",")[1]
                        : ""
                );
                setdisplay3(
                    roomBatch && roomBatch.split(",")[2]
                        ? roomBatch.split(",")[2]
                        : ""
                );
            }
            currentRotation = (currentRotation + 1) % rotations;


        }
    }, [selectedDeviceNameRef.current]);





    useEffect(() => {
        if (token !== null) {
            if (!stompClient || !stompClient.connected) {
                console.log("소켓 실행");
                console.log("소켓 아이디 : " + selectmemberidsoket);


                const newSocket = new SockJS(API_BASE_URL + "/ws");
                const newStomp = Stomp.over(newSocket);

                const headers = { 'sender': selectmemberidsoket, 'type': 'waiting' };
                if (newStomp && newStomp.connected) { // stompClient가 존재하고 연결되어 있는지 확인
                    console.log("WebSocket 연결이 해제되었습니다.");
                    newStomp.disconnect(() => {
                        console.log("WebSocket 연결이 성공적으로 종료되었습니다.");
                    });
                }
                newStomp.connect(
                    headers,
                    function (frame) {
                        console.log("연결 성공 : " + `/queue/waiting-message/${selectmemberidsoket}`);

                        newStomp.subscribe(`/queue/waiting-message/${selectmemberidsoket}`, (message) => {
                            try {
                                // console.log("message: ", message);
                                if (token !== null) {
                                    console.log("리프레시 실행");
                                    // console.log("new 선택한 클럽 정보: ", JSON.stringify(selectedClubInfoRef.current, null, 2));
                                    handleRotate();
                                    onselectedDeviceNameChange(selectedDeviceNameRef.current);
                                }
                            } catch (error) {
                                console.error("Error parsing message:", error);
                            }
                        });

                        setStompClient(newStomp);
                    },
                    (error) => {
                        console.error("Error during WebSocket connection:", error);
                    }
                );
                // 소켓 연결이 끊어졌을 때 재연결을 시도합니다.
                newStomp.ws.onclose = () => {
                    console.log("WebSocket 연결이 끊어졌습니다.");
                    setStompClient(null)
                };

                // WebSocket 연결 에러 처리
                newStomp.ws.onerror = () => {
                    console.log("WebSocket 연결 에러.");
                    setStompClient(null)
                };
            }

            return () => {
                // 컴포넌트 언마운트 시 소켓 연결 해제
                if (stompClient) {
                    stompClient.disconnect(() => {
                        console.log("WebSocket 연결이 해제되었습니다.");
                    });
                }
            };
        };
    }, [token]);


    useEffect(() => {
        if (token !== null) {

            if (!JuminnumberstompClient || !JuminnumberstompClient.connected) {
                console.log("주민번호 소켓 실행");

                console.log("소켓 아이디 : " + selectmemberidsoket);


                const newSocket = new SockJS(API_BASE_URL + "/ws");
                const newStomp = Stomp.over(newSocket);

                const headers = { 'sender': selectmemberidsoket, 'type': 'hospital' };
                if (newStomp && newStomp.connected) { // stompClient가 존재하고 연결되어 있는지 확인
                    console.log("WebSocket 연결이 해제되었습니다.");
                    newStomp.disconnect(() => {
                        console.log("WebSocket 연결이 성공적으로 종료되었습니다.");
                    });
                }
                newStomp.connect(
                    headers,
                    function (frame) {
                        console.log("주민번호 연결 성공 : " + `/queue/subscribe-hospital/${selectedClubInfo?.club_seq}@${selectmemberidsoket}`);
                        setJuminnumberstompClient(newStomp);
                    },
                    (error) => {
                        console.error("Error during WebSocket connection:", error);
                    }
                );
                // 소켓 연결이 끊어졌을 때 재연결을 시도합니다.
                newStomp.ws.onclose = () => {
                    // console.log("WebSocket 연결이 끊어졌습니다.");
                    setJuminnumberstompClient(null)
                };

                // WebSocket 연결 에러 처리
                newStomp.ws.onerror = () => {
                    // console.log("WebSocket 연결 에러.");
                    setJuminnumberstompClient(null)
                };
            }

            return () => {
                // 컴포넌트 언마운트 시 소켓 연결 해제
                if (stompClient) {
                    stompClient.disconnect(() => {
                        console.log("WebSocket 연결이 해제되었습니다.");
                    });
                }
            };
        };
    }, [token]);
    const handleAnswerChange = (e: any, questionIndex: any, answerIndex: any) => {
        const newAnswers = [...answers];
        newAnswers[questionIndex][answerIndex] = e.target.value;
        setAnswers(newAnswers);
    };
    const handleRemoveAnswer = (questionIndex: number, answerIndex: number, type: String) => {
        if (type === "answer") {
            const newAnswers = [...answers];
            newAnswers[questionIndex] = newAnswers[questionIndex].filter((answer, index) => index !== answerIndex);
            setAnswers(newAnswers);
        } else {
            const newAnswers = [...answers];
            const filteredAnswers = newAnswers[questionIndex].filter((answer, index) => {
                console.log("값 : " + answer);
                if (index === answerIndex && answer==="기타####") {
                    return false; // Remove the current "####기타" answer
                }
                return true; // Keep all other answers
            });
            newAnswers[questionIndex] = filteredAnswers;
            setAnswers(newAnswers);
        }

    };
    // const [answers, setAnswers] = useState<string[][]>([[]]);
    const handleRemoveEtcAnswer = (index: number) => {
        const newEtcAnswers = [...etcAnswers];
        newEtcAnswers.splice(index, 1);
        setEtcAnswers(newEtcAnswers);
    };
    const handleAddAnswer = (questionIndex: number, type: string) => {

        console.log(JSON.stringify(answers,null,2))
        const hasEtcAnswer = (answersArr: string[]) => answersArr.some(answer => answer === '기타####');
        if (hasEtcAnswer(answers[questionIndex])) {
            console.log("이미 기타#### 값이 존재합니다.");
            return;
        }

        if (type === "answer") {
            const newAnswers = [...answers];
            newAnswers[questionIndex] = [...newAnswers[questionIndex], ''];
            setAnswers(newAnswers);
        } else {
            const newAnswers = [...answers];
            newAnswers[questionIndex] = [...newAnswers[questionIndex], '기타####'];
            setAnswers(newAnswers);
        }

    };

    const handleAddItem = () => {
        setFamilyInfo((prevFamilyInfo) => [
            ...prevFamilyInfo,
            {
                relationship: "",
                name: "",
                gender: "",
                birthdate: "",
                chartNumber: "",
            },
        ]);
    };
    useEffect(() => {
        if (token !== null) {
            if (waittingdataArray1.length != 0) {
                // console.log("첫번째로우 : " + JSON.stringify(waittingdataArray1, null, 2));
                const transformedData = waittingdataArray1.map((data, index) => {
                    const [waitnumber, membername, phonenumber, state] = data;

                    return {
                        number: index + 1,
                        waitnumber: waitnumber,
                        membername: membername + state,
                    };
                });

                // console.log("첫번째@@ :" + JSON.stringify(transformedData, null, 2));


                setwaitingtabledataArray1(transformedData);
            } else {
                setwaitingtabledataArray1([]);
            }
        }
    }, [waittingdataArray1]);


    useEffect(() => {
        if (token !== null || selectedClubInfo?.club_seq !== 0) {
            fetchWebAgentSettinglist();
        }
    }, [token]);

    useEffect(() => {
        if (token !== null) {
            if (waittingdataArray2.length != 0) {
                const transformedData = waittingdataArray2.map((data, index) => {
                    const [waitnumber, membername, phonenumber, state] = data;

                    return {
                        number: index + 1,
                        waitnumber: waitnumber,
                        membername: membername + state,
                    };
                });
                setwaitingtabledataArray2(transformedData);
            } else {
                setwaitingtabledataArray2([]);
            }
        }
    }, [waittingdataArray2]);

    useEffect(() => {
        if (token !== null) {
            if (waittingdataArray3.length != 0) {
                const transformedData = waittingdataArray3.map((data, index) => {
                    const [waitnumber, membername, phonenumber, state] = data;

                    return {
                        number: index + 1,
                        waitnumber: waitnumber,
                        membername: membername + state,
                    };
                });

                setwaitingtabledataArray3(transformedData);
            } else {
                setwaitingtabledataArray3([]);
            }
        }

    }, [waittingdataArray3]);


    const fetchWebAgentSettinglist = async () => {
        if (token !== null || selectedClubInfo?.club_seq !== 0) {
            const response = await fetch(
                `${API_BASE_URL_ISSUER}/agentsetting/list/` + selectedClubInfo?.club_seq,
                {
                    method: "GET",

                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            const data = await response.json();



            // Filter and map the items with deviceId starting with "tmp_"
            const filteredListtmp = data.data.agentSettingList.filter((item: any) => item.deviceId.startsWith("tmp_"));
            const filteredListform = data.data.agentSettingList.filter((item: any) => item.deviceId.startsWith("form_"));

            const extractedSymptoms = filteredListtmp.map((item: any) => JSON.parse(item.agentSetting).증상);
            const extractedRooms = filteredListtmp.map((item: any) => JSON.parse(item.agentSetting).진료실);


            console.log("1: " + JSON.stringify(extractedSymptoms, null, 2))
            console.log("2: " + JSON.stringify(extractedRooms, null, 2))

            setUserSymptoms(extractedSymptoms.flat());
            setUserRooms(extractedRooms.flat());
            console.log("종이진료과리스트: " + JSON.stringify(filteredListtmp, null, 2))
            console.log("서식리스트: " + JSON.stringify(filteredListform, null, 2))
            setwebagentsettingrowdata(filteredListtmp);
            setwebagentsettingrowdataform(filteredListform);
        }
    }

    const fetchWaitMemberDataAPI_flag1 = async () => {
        if (token !== null && selectedClubInfo?.club_seq !== undefined && selectedClubInfo?.club_seq !== 0) {
            // console.log("fetchWaitMemberDataAPI_flag1 실행")
            try {
                const currentDate = new Date();
                const localOffset = currentDate.getTimezoneOffset() * 60000; // offset in milliseconds
                const correctedDate = new Date(currentDate.getTime() - localOffset);

                const formattedDate = correctedDate.toISOString().split("T")[0];
                const response = await fetch(
                    `${API_BASE_URL}/club/agent/waiting/list/${selectedClubInfo?.club_seq}/${formattedDate}?page=0&size=2000000&sort=agentClubWaitingSeq,desc`,
                    {
                        method: "GET",

                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                const data = await response.json();

                const sortedData = {
                    ...data,
                    data: {
                        ...data.data,
                        content: data.data.content
                            .sort(
                                (a: any, b: any) => a.agentClubWaitingSeq - b.agentClubWaitingSeq
                            )
                            .map((item: any, index: number) => ({
                                ...item,
                                waitnumber: 101 + index,
                            })),
                    },
                };
                if (data.data.content.length !== 0) {
                    setcontentLength(data.data.content.length);
                }
                const excelHeader = ["대기번호", "회원명", "핸드폰번호"];

                const sortedExcelRows = sortedData.data.content
                    .filter((item: any) => item.flag === true)
                    .map((item: any) => {
                        const {
                            waitnumber,
                            chartnumber,
                            memberName,
                            family,
                            Symptom,
                            room,
                            mobileNubmer,
                            flag,
                            created,
                            memberDidSeq,
                            memo,
                        } = item;

                        return {
                            waitnumber,
                            memberName,
                            mobileNubmer,
                            flag,
                            agentClubSeq: item.agentClub.agentClubSeq,
                            // memberDidSeq: item.memberDid.memberDidSeq,
                            created,
                        };
                    })
                    .sort(
                        (a: any, b: any) => a.agentClubWaitingSeq - b.agentClubWaitingSeq
                    );

                const excelRows = sortedExcelRows.map((item: any) => [
                    item.waitnumber,
                    item.memberName,
                    item.mobileNubmer,
                    item.created,
                ]);
                // console.log("엑셀값 : " + JSON.stringify(excelRows,null,2));

                const totalRows = sortedExcelRows.length;
                // console.log("전체개수 : " + totalRows)
                settotalWaitcount1(totalRows);

                // fetchWaitMemberDataAPIrefresh();

                setwaitdataArray([
                    ...excelRows.filter((row: string[]) => row.length > 0),
                ]);
            } catch (error) {
                // console.error("(ExcelUpload) Error fetching data:", error);
            }
        }
    };


    const fetchWaitMemberDataAPI_flag2 = async () => {
        if (token !== null && selectedClubInfo?.club_seq !== undefined && selectedClubInfo?.club_seq !== 0) {
            // console.log("fetchWaitMemberDataAPI_flag2 실행")
            try {
                const currentDate = new Date();
                const localOffset = currentDate.getTimezoneOffset() * 60000; // offset in milliseconds
                const correctedDate = new Date(currentDate.getTime() - localOffset);

                const formattedDate = correctedDate.toISOString().split("T")[0];
                const response = await fetch(
                    `${API_BASE_URL}/club/agent/waiting/list/${selectedClubInfo?.club_seq}/${formattedDate}?page=0&size=200000&sort=agentClubWaitingSeq,desc`,
                    {
                        method: "GET",

                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                const data = await response.json();

                const sortedData = {
                    ...data,
                    data: {
                        ...data.data,
                        content: data.data.content
                            .sort(
                                (a: any, b: any) => a.agentClubWaitingSeq - b.agentClubWaitingSeq
                            )
                            .map((item: any, index: number) => ({
                                ...item,
                                waitnumber: 101 + index,
                            })),
                    },
                };

                if (data.data.content.length !== 0) {
                    setcontentLength(data.data.content.length);
                }

                const sortedExcelRows = sortedData.data.content
                    .filter((item: any) => item.flag === false)
                    .map((item: any) => {
                        const {
                            waitnumber,
                            memberName,
                            mobileNubmer,
                            flag,
                            agentClubSeq,
                            memberDidSeq,
                        } = item;

                        return {
                            waitnumber,
                            memberName,
                            mobileNubmer,
                            flag,
                            agentClubSeq: item.agentClub.agentClubSeq,
                            // memberDidSeq: item.memberDid.memberDidSeq,
                        };
                    })
                    .sort(
                        (a: any, b: any) => a.agentClubWaitingSeq - b.agentClubWaitingSeq
                    );

                const excelRows = sortedExcelRows.map((item: any) => [
                    item.waitnumber,
                    item.memberName,
                    item.mobileNubmer,

                ]);
                const totalRows = sortedExcelRows.length;
                // console.log("전체개수 : " + totalRows)
                settotalWaitcount1(totalRows);

                // fetchWaitMemberDataAPIrefresh();

                setwaitdataArray2([
                    ...excelRows.filter((row: string[]) => row.length > 0),
                ]);
            } catch (error) {
                // console.error("(ExcelUpload) Error fetching data:", error);
            }

        }
    };
    const onWaitButtonClick = async () => {
        console.log("대기완료!")

        // const voices = window.speechSynthesis.getVoices();
        // console.log(voices)
        // const utterance1 = new SpeechSynthesisUtterance("최준환님");
        // const utterance2 = new SpeechSynthesisUtterance("진료실로 입장해주세요");
        // const selectedVoice = voices.find(voice => voice.name === 'Google 한국의 여성'); // 원하는 음성 이름으로 변경

        // if (selectedVoice) {
        //     utterance1.voice = selectedVoice;
        //     utterance2.voice = selectedVoice;
        // }

        // utterance1.rate = 1.0; // 첫 문장의 속도
        // utterance2.rate = 1.0; // 두 번째 문장의 속도

        // utterance1.onend = () => {
        //     setTimeout(() => {
        //         speechSynthesis.speak(utterance2);
        //     }, 700); // 1초 일시 정지 후 두 번째 문장 읽기
        // };

        // speechSynthesis.speak(utterance1);

        //대기완료버튼
        const content = waitingrowdata || [];

        const targetDisplayWaitingNum = firstElement;

        const matchingData = waitingrowdata.find(
            (data) => data.displayWaitingNum === targetDisplayWaitingNum
        );

        // 찾은 경우 출력
        if (matchingData) {
            // console.log(`찾은 agentClubWaitingSeq 값: ${matchingData.agentClubWaitingSeq}`);
        } else {
            console.log(`일치하는 데이터를 찾을 수 없습니다.`);
        }
        // console.log("디아이디 : " + selectdid[0])

        const requestBody: {
            did: string;
            clubSeq: number;
            agentClubWaitingSeq: number;
            flag: boolean;
        } = {
            did: selectdid[0],
            clubSeq: selectedClubInfo?.club_seq || 0,
            agentClubWaitingSeq: matchingData?.agentClubWaitingSeq || 0,
            flag: false,
        };

        try {
            const response = await fetch(
                `${API_BASE_URL}/club/agent/waiting/update`,
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody),
                }
            );
            // console.log("변경사항 : " + JSON.stringify(requestBody));
            const data = await response.json();

            if (response.ok) {
                onselectchangeupdate(true);
                fetchWaitMemberDataAPI_flag1();
                fetchWaitMemberDataAPI_flag2();
                setfirstElement("대기번호");
                setfourthElement("차트번호");
                setsecondElement("회원명");
                setthirdElement("핸드폰번호");
                fetchWaitinglistDataAPII();
                try {
                    const totalRooms = selectroom.length;
                    const rotations = Math.ceil(totalRooms / 3);

                    let currentRotation = 0;

                    setwaitingtabledataArray1([]);
                    setwaitingtabledataArray2([]);
                    setwaitingtabledataArray3([]);
                    setwaittingdataArray1([]);
                    setwaittingdataArray2([]);
                    setwaittingdataArray3([]);

                    setdisplay1(null);
                    setdisplay2(null);
                    setdisplay3(null);

                    const startIndex = currentRotation * 3;
                    const endIndex = Math.min(startIndex + 3, totalRooms);
                    const roomBatch = selectroom.slice(startIndex, endIndex).join(",");

                    if (roomBatch !== "") {
                        setdisplay(roomBatch);
                        setdisplay1(roomBatch ? roomBatch.split(",")[0] : "");
                        setdisplay2(roomBatch && roomBatch.split(",")[1] ? roomBatch.split(",")[1] : "");
                        setdisplay3(roomBatch && roomBatch.split(",")[2] ? roomBatch.split(",")[2] : "");
                    }
                    const displayparam1 = roomBatch ? roomBatch.split(",")[0] : "";
                    const displayparam2 = roomBatch && roomBatch.split(",")[1] ? roomBatch.split(",")[1] : "";
                    const displayparam3 = roomBatch && roomBatch.split(",")[2] ? roomBatch.split(",")[2] : "";

                    fetchWaitMemberviewDataAPI(displayparam1, displayparam2, displayparam3);
                    currentRotation = (currentRotation + 1) % rotations;

                } catch (error) {
                    console.error("Error parsing message:", error);
                }
            } else {
                console.error("(ExcelUpload) Failed to update data:", data);
            }
        } catch (error) {
            console.error("(ExcelUpload) Error updating data:", error);
        }
    };
    const tableviewhandleRowClick = (record: any) => {
        // console.log("클릭됨");
        // console.log("Selected Row Values:", record);
        // console.log("선택한 대기번호 " + record.waitnumber);
        // console.log("확인 " + JSON.stringify(waitingrowdata, null, 2))

        const targetEntry = waitingrowdata.find(
            (entry: any) => entry.displayWaitingNum === record.waitnumber
        );

        if (targetEntry) {
            let membername = null;
            let memberlocalname = null;
            let membermobilenumber = null;
            let memberextradata = null;


            const isnewmember = targetEntry.invitationName;
            const invitationClubValid = targetEntry.invitationClubValid;

            if (isnewmember === "번호접수") {
                membername = targetEntry.memberName;
                memberlocalname = targetEntry.invitationLocalName;
                membermobilenumber = targetEntry.invitationMobileNumber;
                memberextradata = targetEntry.invitationExtraData;
            } else {

                if (invitationClubValid === false) {
                    membername = targetEntry.memberName;
                    memberlocalname = targetEntry.localName;
                    membermobilenumber = targetEntry.mobileNumber;
                    memberextradata = targetEntry.extraData;
                } else {
                    membername = targetEntry.invitationName;
                    memberlocalname = targetEntry.invitationLocalName;
                    membermobilenumber = targetEntry.invitationMobileNumber;
                    memberextradata = targetEntry.invitationExtraData;
                }


            }

            const firstElement = record.waitnumber; // First element
            const secondElement = membername; // Second element
            const thirdElement = membermobilenumber; // Third element
            const fourthElement = memberlocalname; // Third element

            setfirstElement(firstElement || "대기번호");
            setsecondElement(secondElement || "회원명");
            setthirdElement(thirdElement || "휴대번호");
            setfourthElement(fourthElement || "차트번호");
        } else {
        }
    };



    const fetchWaitMemberviewDataAPI = async (
        displayparam1: string,
        displayparam2: string,
        displayparam3: string
    ) => {
        if (token !== null && selectedClubInfo?.club_seq !== undefined && selectedClubInfo?.club_seq !== 0 && selectedDeviceNameRef.current !== "") {
            try {
                const currentDate = new Date();
                const localOffset = currentDate.getTimezoneOffset() * 60000; // offset in milliseconds
                const correctedDate = new Date(currentDate.getTime() - localOffset);

                const formattedDate = correctedDate.toISOString().split("T")[0];
                console.log(`${API_BASE_URL}/club/agent/reception/waiting/list/department/${selectedClubInfo?.club_seq}/${formattedDate}/${selectedDeviceNameRef.current}?page=0&size=10000&sort=agentClubWaitingSeq,desc`)
                // const fetchWithTimeout = async (url: string, options: RequestInit, timeout = 10000): Promise<Response> => {
                //     const startTime = Date.now(); // 시작 시간 기록
                //     try {
                //         const response = await Promise.race([
                //             fetch(url, options),
                //             new Promise<Response>((_, reject) =>
                //                 setTimeout(() => reject(new Error('3초 지남')), timeout)
                //             )
                //         ]);
                //         const endTime = Date.now(); // 종료 시간 기록
                //         const elapsedTime = (endTime - startTime) / 1000; // 경과 시간 계산 (밀리초를 초로 변환)
                //         console.log(`Elapsed time: ${elapsedTime} seconds`); // 경과 시간을 콘솔에 출력
                //         return response as Response;
                //     } catch (error) {
                //         throw new Error(`Error fetching data: ${error}`);
                //     }
                // };

                fetch(
                    // fetchWithTimeout(
                    `${API_BASE_URL}/club/agent/reception/waiting/list/department/${selectedClubInfo?.club_seq}/${formattedDate}/${selectedDeviceNameRef.current}?page=0&size=10000&sort=agentClubWaitingSeq,desc`,
                    {
                        method: "GET", // POST 메서드 사용  
                        headers: {
                            "Content-Type": "application/json", // 요청 헤더에 JSON 형식으로 데이터 전송
                            Authorization: `Bearer ${token}`,
                        },
                    }
                )
                    .then((response) => response.json())
                    .then((data) => {
                        const sortedData = data.data && data.data.content
                            ? {
                                ...data,
                                data: {
                                    ...data.data,
                                    content: data.data.content
                                        .sort(
                                            (a: any, b: any) =>
                                                a.agentClubWaitingSeq - b.agentClubWaitingSeq
                                        )
                                        .map((item: any, index: number) => ({
                                            ...item
                                        })),
                                },
                            }
                            : null;
                        if (data.data && data.data.content && data.data.content.length !== 0) {
                            setcontentLength(data.data.content.length);
                        }
                        // console.log("로우로우~로우값 : " + JSON.stringify(sortedData))
                        const sortedExcelRows = sortedData && sortedData.data && sortedData.data.content
                            .filter((item: any) => item.flag === true)
                            .map((item: any) => {
                                const { memberName, mobileNumber, flag } = item;

                                return {
                                    waitnumber: item.displayWaitingNum,
                                    memberName,
                                    mobileNumber,
                                    flag,
                                    agentClubSeq: item.agentClub.agentClubSeq,
                                    // memberDidSeq: item.memberDid.memberDidSeq,
                                    questionnaireFirst: item.questionnaireFirst,
                                    invitationEmptyLocalNameValid: item.invitationEmptyLocalNameValid,
                                    invitationClubValid: item.invitationClubValid,
                                    invitationLocalName: item.invitationLocalName,
                                    invitationMobileNumber: item.invitationMobileNumber,
                                    invitationName: item.invitationName,
                                    questionnaire: item.questionnaire,
                                    localName: item.localName
                                };
                            })
                            .sort(
                                (a: any, b: any) =>
                                    a.agentClubWaitingSeq - b.agentClubWaitingSeq
                            );

                        // console.log("정리된거  : " + JSON.stringify(sortedExcelRows,null,2))


                        const excelRows = sortedExcelRows ?
                            sortedExcelRows.map((item: any) => [
                                item.waitnumber,
                                item.memberName,
                                item.mobileNumber,
                                item.questionnaire,
                                item.invitationEmptyLocalNameValid,
                                item.invitationClubValid,
                                item.invitationLocalName,
                                item.invitationMobileNumber,
                                item.invitationName,
                                item.questionnaireFirst,
                                item.localName
                            ]) : [];
                        let waittingdataArray1: any[] = [];
                        let waittingdataArray2: any[] = [];
                        let waittingdataArray3: any[] = [];

                        console.log("로우~로우값 : " + JSON.stringify(excelRows, null, 2))
                        excelRows.forEach((row: any, index: number) => {
                            const questionnaireValue = row[3];
                            let trimmedValue = "";
                            let isnewmember = row[8];
                            const invitationClubValid = row[5];
                            if (questionnaireValue) {
                                if (questionnaireValue.includes("#")) {
                                    if (questionnaireValue.includes(",")) {
                                        if (questionnaireValue !== undefined && questionnaireValue !== null) {
                                            const values = questionnaireValue.split("#");
                                            // console.log("벨류 : " + values)
                                            const tempValue = values[1].split(",");
                                            const lastValue = tempValue[0]
                                            trimmedValue = lastValue.replace("#", "").replace("]", "").trim();
                                        }

                                    }
                                }
                            }


                            let membername = null;
                            let memberlocalname = null;
                            let membermobilenumber = null;
                            let state = null;



                            if (isnewmember === "번호접수") {
                                membername = excelRows[index][1];
                                memberlocalname = excelRows[index][6];
                                membermobilenumber = excelRows[index][7];
                            } else {
                                if (invitationClubValid === false) {
                                    membername = excelRows[index][1];
                                    memberlocalname = excelRows[index][11];
                                    membermobilenumber = excelRows[index][2];
                                } else {
                                    membername = excelRows[index][8];
                                    memberlocalname = excelRows[index][6];
                                    membermobilenumber = excelRows[index][7];
                                }
                            }
                            if (membername === "") {
                                membername = excelRows[index][1];
                            }
                            if (/^\d{4}님$/.test(membername) && memberlocalname === "") {
                                state = " no name";

                            } else {
                                state = "";
                            }
                            if (memberlocalname === "" || memberlocalname === undefined) {
                                state = " no chart";
                            }
                            if (/^\d{4}님$/.test(membername)) {
                                state = " no name";
                            }

                            if (trimmedValue === displayparam1) {
                                if (trimmedValue.trim() !== "" && displayparam1.trim() !== "") {
                                    // console.log("최종이름 : " + membername)
                                    const waitNumber = excelRows[index][0];
                                    waittingdataArray1.push([waitNumber, membername, membermobilenumber, state]);
                                }
                            }

                            if (trimmedValue === displayparam2) {
                                if (trimmedValue.trim() !== "" && displayparam2.trim() !== "") {
                                    const waitNumber = excelRows[index][0];
                                    waittingdataArray2.push([waitNumber, membername, membermobilenumber, state]);
                                }
                            }
                            if (trimmedValue === displayparam3) {
                                if (trimmedValue.trim() !== "" && displayparam3.trim() !== "") {
                                    const waitNumber = excelRows[index][0];
                                    waittingdataArray3.push([waitNumber, membername, membermobilenumber, state]);
                                }
                            }

                            // console.log("진료실여부 : " + selectrooms.length);
                            if (selectrooms.length === 1) {
                                const waitNumber = excelRows[index][0];
                                // console.log(waitNumber);
                                // console.log(membername);
                                // console.log(membermobilenumber);
                                // console.log(state);

                                waittingdataArray1.push([waitNumber, membername, membermobilenumber, state]);
                                setdisplay1("진료실")
                            }
                        });
                        // console.log("첫번째테이블 값 : " + JSON.stringify(waittingdataArray1, null, 2))
                        // console.log("두번째테이블 값 : " + JSON.stringify(waittingdataArray2, null, 2))
                        // console.log("세번째테이블 값 : " + JSON.stringify(waittingdataArray3, null, 2))
                        setwaittingdataArray1([...waittingdataArray1]);
                        setwaittingdataArray2([...waittingdataArray2]);
                        setwaittingdataArray3([...waittingdataArray3]);

                    });
            } catch (error) {
                // console.error("(ExcelUpload) Error fetching data:", error);
            }
        }
    };
    const fetchWaitinglistDataAPII = async () => {

        if (token !== null && selectedClubInfoRef.current?.club_seq !== undefined && selectedClubInfoRef.current?.club_seq !== 0 && selectedDeviceNameRef.current !== undefined) {
            const currentDate = new Date();

            const localOffset = currentDate.getTimezoneOffset() * 60000; // offset in milliseconds
            const correctedDate = new Date(currentDate.getTime() - localOffset);

            const formattedDate = correctedDate.toISOString().split("T")[0];


            console.log(`${API_BASE_URL}/club/agent/reception/waiting/list/department/${selectedClubInfoRef.current?.club_seq}/${formattedDate}/${selectedDeviceNameRef.current}?page=0&size=10000&sort=agentClubWaitingSeq,desc`)
            // const fetchWithTimeout = async (url: string, options: RequestInit, timeout = 10000): Promise<Response> => {
            //     const startTime = Date.now(); // 시작 시간 기록
            //     try {
            //         const response = await Promise.race([
            //             fetch(url, options),
            //             new Promise<Response>((_, reject) =>
            //                 setTimeout(() => reject(new Error('3초 지남')), timeout)
            //             )
            //         ]);
            //         const endTime = Date.now(); // 종료 시간 기록
            //         const elapsedTime = (endTime - startTime) / 1000; // 경과 시간 계산 (밀리초를 초로 변환)
            //         console.log(`Elapsed time: ${elapsedTime} seconds`); // 경과 시간을 콘솔에 출력
            //         return response as Response;
            //     } catch (error) {
            //         throw new Error(`Error fetching data: ${error}`);
            //     }
            // };


            fetch(
                // fetchWithTimeout(
                `${API_BASE_URL}/club/agent/reception/waiting/list/department/${selectedClubInfoRef.current?.club_seq}/${formattedDate}/${selectedDeviceNameRef.current}?page=0&size=10000&sort=agentClubWaitingSeq,desc`,
                {
                    method: "GET", // POST 메서드 사용  
                    headers: {
                        "Content-Type": "application/json", // 요청 헤더에 JSON 형식으로 데이터 전송
                        Authorization: `Bearer ${token}`,
                    },
                }
            )
                .then((response) => response.json() as Promise<any>)
                .then((data) => {
                    // console.log("fetchWaitinglistDataAPII실행 ")
                    console.log("대기값 로우 : " + JSON.stringify(data.data, null, 2))
                    if (data && data.data && data.data.content) {


                        setwaitingrowdata(data.data.content);
                        const extractedData1 = data.data.content
                            .filter((item: any) => item.flag === true)
                            .map((item: any, index: any) => {
                                const invitationEmptyLocalNameValid = item.invitationEmptyLocalNameValid;
                                const invitationClubValid = item.invitationClubValid;
                                const isnewmember = item.invitationName;

                                let membername = null;
                                let memberlocalname = null;
                                let membermobilenumber = null;
                                let memberextradata = null;
                                let created = item.created.split("T")[1];

                                if (isnewmember === "번호접수") {
                                    membername = item.memberName;
                                    memberlocalname = item.invitationLocalName;
                                    membermobilenumber = item.invitationMobileNumber;
                                    memberextradata = item.invitationExtraData;
                                } else {

                                    if (invitationClubValid === false) {
                                        membername = item.memberName;
                                        memberlocalname = item.localName;
                                        membermobilenumber = item.mobileNumber;
                                        memberextradata = item.extraData;
                                    } else {
                                        membername = item.invitationName;
                                        memberlocalname = item.invitationLocalName;
                                        membermobilenumber = item.invitationMobileNumber;
                                        memberextradata = item.invitationExtraData;
                                    }


                                }
                                if (membername === "") {
                                    membername = item.memberName;
                                }


                                let symptomsWithoutBrackets = "";
                                let symptomsBrackets = "";
                                let roomWithoutBrackets = "";
                                let firstroom = "";
                                try {

                                    if (item.questionnaireFirst) {
                                        if (item.questionnaireFirst.includes("#")) {
                                            if (item.questionnaireFirst.includes(",")) {
                                                if (item.questionnaireFirst !== null) {
                                                    symptomsWithoutBrackets = item.questionnaireFirst.replace(/\[/g, "").replace(/\]/g, "");

                                                    symptomsBrackets = symptomsWithoutBrackets.split("#")[0].trim();

                                                    if (symptomsBrackets.endsWith(",")) {
                                                        symptomsBrackets = symptomsBrackets.slice(0, -1);
                                                    }

                                                    firstroom = item.questionnaireFirst.split("#")[1].split(",")[0]

                                                }
                                            }


                                        }

                                    } else {
                                        firstroom = ""
                                    }

                                    if (item.questionnaire) {
                                        if (item.questionnaire.includes("#")) {
                                            if (item.questionnaire.includes(",")) {
                                                if (item.questionnaire !== null) {
                                                    symptomsWithoutBrackets = item.questionnaire.replace(/\[/g, "").replace(/\]/g, "");
                                                    roomWithoutBrackets = symptomsWithoutBrackets.split("#")[1].split("@")[0].replace(/,/g, "");
                                                }
                                            }


                                        }

                                    }

                                } catch (error) {

                                }


                                return {

                                    대기번호: item.displayWaitingNum || 0,
                                    차트번호: memberlocalname || null,
                                    회원명: membername || null,
                                    가족: memberextradata ? JSON.parse(memberextradata).가족 : null,
                                    내원증상: symptomsBrackets || "",
                                    진료실: roomWithoutBrackets ? roomWithoutBrackets : "",
                                    전화번호: membermobilenumber || null,
                                    접수시간: created,
                                    희망진료실: firstroom,
                                    수진자확인: memberextradata ? (JSON.stringify(JSON.parse(memberextradata).수신자자격) !== undefined ? JSON.stringify(JSON.parse(memberextradata).수신자자격.수진자자격확인결과).replace(/"/g, '') : null) : null,
                                    회원여부: item.invitationClubValid
                                    // didseq: item.memberDid?.memberDidSeq||0
                                };
                            })
                            .sort((a: any, b: any) => b.대기번호 - a.대기번호);




                        setwaitingrowdata1(data.data.content);

                        const extractedData2 = data.data.content
                            .filter((item: any) => item.flag === false && item.updated !== null)  // Add filter for items where flag is true
                            .map((item: any, index: any) => {
                                const invitationEmptyLocalNameValid = item.invitationEmptyLocalNameValid;
                                const invitationClubValid = item.invitationClubValid;
                                const isnewmember = item.invitationName;



                                let membername = null;
                                let memberlocalname = null;
                                let membermobilenumber = null;
                                let memberextradata = null;

                                let created = item.created.split("T")[1];
                                if (isnewmember === "번호접수") {
                                    membername = item.memberName;
                                    memberlocalname = item.invitationLocalName;
                                    membermobilenumber = item.invitationMobileNumber;
                                    memberextradata = item.invitationExtraData;
                                } else {

                                    if (invitationClubValid === false) {
                                        membername = item.memberName;
                                        memberlocalname = item.localName;
                                        membermobilenumber = item.mobileNumber;
                                        memberextradata = item.extraData;
                                    } else {
                                        membername = item.invitationName;
                                        memberlocalname = item.invitationLocalName;
                                        membermobilenumber = item.invitationMobileNumber;
                                        memberextradata = item.invitationExtraData;
                                    }


                                }

                                // console.log("extradata@@ : " + memberextradata)


                                let symptomsWithoutBrackets = "";
                                let symptomsBrackets = "";
                                let roomWithoutBrackets = "";
                                let firstroom = "";
                                try {

                                    if (item.questionnaireFirst) {
                                        if (item.questionnaireFirst.includes("#")) {
                                            if (item.questionnaireFirst.includes(",")) {
                                                if (item.questionnaireFirst !== null) {
                                                    symptomsWithoutBrackets = item.questionnaireFirst.replace(/\[/g, "").replace(/\]/g, "");
                                                    symptomsBrackets = symptomsWithoutBrackets.split("#")[0].trim();

                                                    if (symptomsBrackets.endsWith(",")) {
                                                        symptomsBrackets = symptomsBrackets.slice(0, -1);
                                                    }
                                                    firstroom = item.questionnaireFirst.split("#")[1].split(",")[0]

                                                }
                                            }


                                        }

                                    } else {
                                        firstroom = ""
                                    }
                                    if (item.questionnaire) {
                                        if (item.questionnaire.includes("#")) {
                                            if (item.questionnaire.includes(",")) {
                                                if (item.questionnaire !== null) {
                                                    symptomsWithoutBrackets = item.questionnaire.replace(/\[/g, "").replace(/\]/g, "");
                                                    roomWithoutBrackets = symptomsWithoutBrackets.split("#")[1].split("@")[0].replace(/,/g, "");
                                                }
                                            }


                                        }

                                    }

                                } catch (error) {

                                }
                                // console.log("내원증상 " + symptomsBrackets);

                                return {
                                    업데이트: item.updated || null,
                                    대기번호: item.displayWaitingNum || 0,
                                    차트번호: memberlocalname || null,
                                    회원명: membername || null,
                                    가족: memberextradata ? JSON.parse(memberextradata).가족 : null,
                                    내원증상: symptomsBrackets || "",
                                    진료실: roomWithoutBrackets ? roomWithoutBrackets : "",
                                    전화번호: membermobilenumber || null,
                                    접수시간: created,
                                    수진자확인: memberextradata ? (JSON.stringify(JSON.parse(memberextradata).수신자자격) !== undefined ? JSON.stringify(JSON.parse(memberextradata).수신자자격.수진자자격확인결과).replace(/"/g, '') : null) : null,

                                    // ${item['성별'] === '남' ? 'M' : 'F'}/` + calculateAge(`${item['생년월일']}`
                                };
                            })
                            .sort((a: any, b: any) => new Date(b.업데이트).getTime() - new Date(a.업데이트).getTime());

                        // console.log("가져온값!@@@ : " + JSON.stringify(extractedData1))
                        // console.log("Table Data개수: ", extractedData.length);
                        setwaitingdata(extractedData1);
                        setbeforreceiptcount(extractedData1.length);
                        setwaitingdata1(extractedData2);
                        setbeforreceiptcount1(extractedData2.length);
                    }
                })
                .catch((error) => {
                    console.error(" Error:", error);
                });
        }
    };
    const handleRemoveItem = (index: number) => {
        setFamilyInfo((prevFamilyInfo) =>
            prevFamilyInfo.filter((_, i) => i !== index)
        );
    };

    const handleGenderChange = (value: any, field: string, index: number) => {
        // console.log("선택값 : " + value);

        setFamilyInfo((prevFamilyInfo) =>
            prevFamilyInfo.map((info, i) =>
                i === index ? { ...info, [field]: value } : info
            )
        );
    };

    const handlerelationshipChange = (value: any, field: string, index: number) => {
        // console.log("선택값 : " + value);

        setFamilyInfo((prevFamilyInfo) =>
            prevFamilyInfo.map((info, i) =>
                i === index ? { ...info, [field]: value } : info
            )
        );
    };

    const handleInputChange = (
        event: React.ChangeEvent<HTMLInputElement | { value: any }>, // input 엘리먼트 이외의 경우를 처리하기 위해 { value: any } 추가
        field: string,
        index: number
    ) => {
        const { value } = event.target || {}; // event.target이 존재하지 않을 경우를 대비해 기본값 설정
        // console.log("선택값 : " + value)

        // 이벤트 객체에서 value 속성에 안전하게 접근하여 값 가져오기
        setFamilyInfo((prevFamilyInfo) =>
            prevFamilyInfo.map((info, i) =>
                i === index ? { ...info, [field]: value } : info
            )
        );
    };


    const handleRightButtonClick = () => {
        try {
            const totalRooms = selectroom.length;
            if (totalRooms > 0) {
                const rotations = Math.ceil(totalRooms / 3);

                if (count < rotations - 1) {
                    const currentRotation = count + 1;
                    const startIndex = currentRotation * 3;
                    const endIndex = Math.min(startIndex + 3, totalRooms);
                    const roomBatch = selectroom.slice(startIndex, endIndex).join(",");

                    setCount(count + 1);
                    setdisplay(roomBatch);
                    setdisplay1(roomBatch ? roomBatch.split(",")[0] : "");
                    setdisplay2(roomBatch && roomBatch.split(",")[1] ? roomBatch.split(",")[1] : "");
                    setdisplay3(roomBatch && roomBatch.split(",")[2] ? roomBatch.split(",")[2] : "");
                    const displayparam1 = roomBatch ? roomBatch.split(",")[0] : "";
                    const displayparam2 = roomBatch && roomBatch.split(",")[1] ? roomBatch.split(",")[1] : "";
                    const displayparam3 = roomBatch && roomBatch.split(",")[2] ? roomBatch.split(",")[2] : "";
                    // console.log(displayparam1);
                    // console.log(displayparam2);
                    // console.log(displayparam3);
                    fetchWaitMemberviewDataAPI(displayparam1, displayparam2, displayparam3);
                } else {
                    handleLeftButtonClick();
                }
            }
        } catch (error) {

        }

    };



    const handleSelectChange = (record: any, value: any) => {



        const updatedTableData = tableData.map((row: any) =>
            row.key === record.key ? { ...row, 진료실: value } : row
        );
        // console.log("선택박스 클릭");

        // console.log("리스트 : " + JSON.stringify(waitingdata))

        const agentClubWaitingSeq = waitingrowdata.find(
            (data) => data.displayWaitingNum === firstElement
        )?.agentClubWaitingSeq;
        // console.log("찾았다 시퀑승:", agentClubWaitingSeq);
        // console.log("바꾼값 : " + value);

        const combinedValues =
            record.내원증상 !== undefined
                ? [record.내원증상, `#${value}, @${selectedDeviceNameRef.current}`]
                : [`#${value}, @${selectedDeviceNameRef.current}`];

        // console.log(combinedValues);
        const postData = {
            agentClubWaitingSeq: agentClubWaitingSeq,
            questionnaire: combinedValues,
        };
        // console.log("수정사항 :" + JSON.stringify(postData));
        console.log(`${API_BASE_URL}/club/agent/waiting/questionnaire/update`);
        // console.log(`${token}`);
        fetch(`${API_BASE_URL}/club/agent/waiting/questionnaire/update`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(postData),
        })
            .then((response) => response.json())
            .then((data) => {
                // console.log("(ExcelUpload) PUT 요청 성공:", data);

                // 새로운 공지사항 데이터를 notices 상태에 추가
                console.log("진료실 수정완료");

                onselectchangeupdate(true);

                // handleRotate();
                // try {
                //     fetchWaitinglistDataAPII();
                //     const totalRooms = selectroom.length;
                //     const rotations = Math.ceil(totalRooms / 3);

                //     let currentRotation = 0;

                //     setwaitingtabledataArray1([]);
                //     setwaitingtabledataArray2([]);
                //     setwaitingtabledataArray3([]);
                //     setwaittingdataArray1([]);
                //     setwaittingdataArray2([]);
                //     setwaittingdataArray3([]);

                //     setdisplay1(null);
                //     setdisplay2(null);
                //     setdisplay3(null);
                //     const startIndex = currentRotation * 3;
                //     const endIndex = Math.min(startIndex + 3, totalRooms);
                //     const roomBatch = selectroom.slice(startIndex, endIndex).join(",");
                //     if (roomBatch !== "") {
                //         setdisplay(roomBatch);
                //         setdisplay1(roomBatch ? roomBatch.split(",")[0] : "");
                //         setdisplay2(roomBatch && roomBatch.split(",")[1] ? roomBatch.split(",")[1] : "");
                //         setdisplay3(roomBatch && roomBatch.split(",")[2] ? roomBatch.split(",")[2] : "");
                //     }
                //     // const displayparam1 = roomBatch ? roomBatch.split(",")[0] : "";
                //     // const displayparam2 = roomBatch && roomBatch.split(",")[1] ? roomBatch.split(",")[1] : "";
                //     // const displayparam3 = roomBatch && roomBatch.split(",")[2] ? roomBatch.split(",")[2] : "";
                //     // console.log("실행9")
                //     // fetchWaitMemberviewDataAPI(displayparam1, displayparam2, displayparam3);
                //     // currentRotation = (currentRotation + 1) % rotations;

                // } catch (error) {
                //     console.error("Error parsing message:", error);
                // }
            });

        setTableData(updatedTableData);
    };

    const juminNumberhandleConfirm = () => {
        if (JuminnumberstompClient) {
            let clubmemberflag;

            // console.log("회원여부 : " + selectclubviled)

            // console.log("플레그1 : " + selectholderid)
            // console.log("플레그2 : " + selectmemberidsoket)
            if (selectclubviled === false) {
                clubmemberflag = true;
            } else {
                clubmemberflag = false;
            }
            // waitinputjuminNumber 주민번호
            // console.log("입력한 이름 : " + selectwaitModalname)
            // console.log("입력한 주민번호 : " + waitinputjuminNumber)
            // console.log("최종 홀더 : " + selectholderid.split(",")[0].replace(/"/g, '').replace(/\[/g, "").replace(/\]/g, "").trim())

            // console.log("최종회원여부 : " + clubmemberflag)
            JuminnumberstompClient.send("/app/rabbit/send-hospital", {}, JSON.stringify({
                'clubSeq': selectedClubInfo?.club_seq,
                'routingKey': selectedClubInfo?.club_seq + "@" + selectmemberidsoket,
                'sender': selectmemberidsoket,
                //'receiver': selectwaitModalname,
                'name': selectwaitModalname,
                'receiver': selectholderid.split(",")[0].replace(/"/g, '').replace(/\[/g, "").replace(/\]/g, "").trim(),
                'mobileNumber': selectwaitModalphonenumber,
                'juminNumberSaved': true,
                'juminNumber': waitinputjuminNumber,
                'localName': selectwaitModallocalname,
                'juminNumberRequestFlag': true,
                'clubMemberFlag': clubmemberflag
            }));
            // console.log("전송한 메세지 : " + JSON.stringify({
            //     'clubSeq': selectedClubInfo?.club_seq,
            //     'routingKey': selectedClubInfo?.club_seq + "@" + selectmemberidsoket,
            //     'sender': selectmemberidsoket,
            //     //'receiver': selectwaitModalname,
            //     'name': selectwaitModalname,
            //     'receiver': selectholderid.split(",")[0].replace(/"/g, '').replace(/\[/g, "").replace(/\]/g, "").trim(),
            //     'mobileNumber': selectwaitModalphonenumber,
            //     'juminNumberSaved': true,
            //     'juminNumber': waitinputjuminNumber,
            //     'localName': selectwaitModallocalname,
            //     'juminNumberRequestFlag': true,
            //     'clubMemberFlag': clubmemberflag
            // }))
            setTimeout(handleRotate, 4000);
            setIsModalVisible2(false)
        }

    };

    const handleConfirm = () => {
        // console.log("가족저장")
        setBirthdate("")
        if (isselectmember === true) {
            // console.log("기존 api")


            const combinedFamilyInfo = {
                가족: familyInfo.map((info) => ({
                    관계: info.relationship,
                    이름: info.name,
                    성별: info.gender,
                    생년월일: info.birthdate
                        ? moment(info.birthdate).format("YYYY-MM-DD")
                        : "", // 날짜 형식 변환
                    차트번호: info.chartNumber,
                })),
            };
            if (!familyInfo.every(info => info.gender === '남' || info.gender === '여')) {
                alert('성별은 "남" 또는 "여"로 입력해주세요.');
                return; // 함수 종료
            }
            // 콘솔에 출력
            // console.log(JSON.stringify(combinedFamilyInfo));

            const postData = {
                clubMemberSeq: selectclubMemberSeq,
                extraData: combinedFamilyInfo,
            };

            // console.log("보내는값 : " + JSON.stringify(postData));

            fetch(`${API_BASE_URL}/club/member/extradata/update`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(postData),
            })
                .then((response) => response.json())
                .then((data) => {
                    // console.log("(ExcelUpload) PUT 요청 성공:", data);
                    // console.log("진료실 수정완료");
                    setIsModalVisible(false);
                });
        } else {
            // console.log("신규 api")


            const combinedFamilyInfo = {
                가족: familyInfo.map((info) => ({
                    관계: info.relationship,
                    이름: info.name,
                    성별: info.gender,
                    생년월일: info.birthdate
                        ? moment(info.birthdate).format("YYYY-MM-DD")
                        : "", // 날짜 형식 변환
                    차트번호: info.chartNumber,
                })),
            };
            if (!familyInfo.every(info => info.gender === '남' || info.gender === '여')) {
                alert('성별은 "남" 또는 "여"로 입력해주세요.');
                return; // 함수 종료
            }


            const patchData = {
                clubSeq: selectedClubInfo?.club_seq,
                mobileNumber: selectfamilymodalphonenumber,
                extraData: JSON.stringify(combinedFamilyInfo),
            };
            // console.log("수정될 데이터 : " + JSON.stringify(patchData))

            fetch(`${API_BASE_URL_ISSUER}/invitations/localname/extradata`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify(patchData),
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then(data => {
                    // fetchroomDataAPI();


                    setIsModalVisible(false);


                })
                .catch(error => {
                    console.error('There was an error with the PATCH request:', error);
                });




        }
        handleRotate();

    };
    const handleAgentSettingSelectChange = (value: string) => {
        setwaitingdata([]);
        setwaitingdata1([]);




        const selectedValue = value;
        console.log("선택한 진료과 :", selectedValue);
        onselectedDeviceNameChange(selectedValue);

        const filterDataByDeviceName = (data: any, selectedValue: any) => {
            const filteredData = [];

            for (const list of data) {
                for (const item of list) {
                    if (item.deviceName === selectedValue) {
                        filteredData.push(item);
                    }
                }
            }

            return filteredData;
        };
        const filteredData = filterDataByDeviceName(agentsettingalldata, selectedValue);
        setselecteagentSetting(filteredData);
        setSelectedDeviceName(selectedValue);
    };

    const handleAgentSettingChange = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {

        setwaitingdata([]);
        setwaitingdata1([]);
        const selectedValue = event.target.value;
        console.log("선택한 진료과 :", selectedValue);
        onselectedDeviceNameChange(selectedValue);

        const filterDataByDeviceName = (data: any, selectedValue: any) => {
            const filteredData = [];

            for (const list of data) {
                for (const item of list) {
                    if (item.deviceName === selectedValue) {
                        filteredData.push(item);
                    }
                }
            }

            return filteredData;
        };

        const filteredData = filterDataByDeviceName(agentsettingalldata, selectedValue);

        setselecteagentSetting(filteredData);
        setSelectedDeviceName(selectedValue);

    };

    const handleRotate = () => { //새로고침
        setIsRotating(true);
        console.log("새로고침 실행@@@@@@@@@@@@@@@@@@@@@@@@@@@@")
        // const newSocket = new SockJS(API_BASE_URL + "/ws");
        // const newStomp = Stomp.over(newSocket);
        // if (!stompClient || !stompClient.connected) {
        //     console.log("대기소켓없음")
        //     const headers = { 'sender': selectmemberidsoket, 'admin': 'true' };
        //     newStomp.connect(
        //         headers,
        //         function (frame) {
        //             console.log("연결 성공");

        //             newStomp.subscribe(`/queue/waiting-message/${selectmemberidsoket}`, (message) => {
        //                 try {
        //                     console.log("message: ", message);
        //                     if (token !== null) {
        //                         console.log("리프레시 실행");
        //                         console.log("new 선택한 클럽 정보: ", JSON.stringify(selectedClubInfoRef.current, null, 2));
        //                         fetchWaitinglistDataAPII();
        //                     }
        //                 } catch (error) {
        //                     console.error("Error parsing message:", error);
        //                 }
        //             });

        //             setStompClient(newStomp);
        //         },
        //         (error) => {
        //             console.error("Error during WebSocket connection:", error);
        //         }
        //     );
        // }else{
        //     console.log("이미대기소켓있음")
        // }


        // if (!JuminnumberstompClient || !JuminnumberstompClient.connected) {
        //     console.log("주민소켓없음")
        //     const headers = { 'sender': selectmemberidsoket, 'admin': 'true' };
        //     newStomp.connect(
        //         headers,
        //         function (frame) {
        //             console.log("연결 성공");

        //             newStomp.subscribe(`/queue/waiting-message/${selectmemberidsoket}`, (message) => {
        //                 try {
        //                     console.log("message: ", message);
        //                     if (token !== null) {
        //                         console.log("리프레시 실행");
        //                         console.log("new 선택한 클럽 정보: ", JSON.stringify(selectedClubInfoRef.current, null, 2));
        //                     }
        //                 } catch (error) {
        //                     console.error("Error parsing message:", error);
        //                 }
        //             });

        //             setJuminnumberstompClient(newStomp);
        //         },
        //         (error) => {
        //             console.error("Error during WebSocket connection:", error);
        //         }
        //     );
        // }else{
        //     console.log("이미주민소켓있음")
        // }

        setwaitingtabledataArray1([]);
        setwaitingtabledataArray2([]);
        setwaitingtabledataArray3([]);
        setwaittingdataArray1([]);
        setwaittingdataArray2([]);
        setwaittingdataArray3([]);

        setdisplay1(null);
        setdisplay2(null);
        setdisplay3(null);

        const totalRooms = selectroom.length;
        const rotations = Math.ceil(totalRooms / 3);
        let currentRotation = 0;
        fetchWaitinglistDataAPII();
        const startIndex = currentRotation * 3;
        const endIndex = Math.min(startIndex + 3, totalRooms);
        const roomBatch = selectroom.slice(startIndex, endIndex).join(",");
        if (roomBatch !== "") {
            setdisplay(roomBatch);
            setdisplay1(roomBatch ? roomBatch.split(",")[0] : "");
            setdisplay2(roomBatch && roomBatch.split(",")[1] ? roomBatch.split(",")[1] : "");
            setdisplay3(roomBatch && roomBatch.split(",")[2] ? roomBatch.split(",")[2] : "");
        }
        const displayparam1 = roomBatch ? roomBatch.split(",")[0] : "";
        const displayparam2 = roomBatch && roomBatch.split(",")[1] ? roomBatch.split(",")[1] : "";
        const displayparam3 = roomBatch && roomBatch.split(",")[2] ? roomBatch.split(",")[2] : "";
        currentRotation = (currentRotation + 1) % rotations;
        fetchWaitMemberviewDataAPI(displayparam1, displayparam2, displayparam3);

        setTimeout(() => setIsRotating(false), 500); // 3초 후에 회전을 멈춥니다.
    };
    const waitlocalnamehandleInputChange = (e: any) => {

        setnewwaitlocalname(e.target.value);
    };

    const waitjunminNumberhandleInputChange = (e: any) => {

        setwaitinputjuminNumber(e.target.value);
    };

    const memberwaitlocalnamehandleInputChange = (e: any) => {

        setmemberwaitlocalname(e.target.value);
    };


    const waitnamehandleInputChange = (e: any) => {
        setnewwaitname(e.target.value);
    };
    const QrlasttimeInputChange = (e: any) => {
        setQrlasttime(e.target.value)
    };
    const qrdevicehandleInputChange = (e: any) => {
        setnewqrdevice(e.target.value);
    };

    const memberwaitnamehandleInputChange = (e: any) => {
        setmemberwaitname(e.target.value);
    };
    const handleLeftButtonClick = () => {
        try {
            const totalRooms = selectroom.length;
            if (totalRooms > 0) {
                const rotations = Math.ceil(totalRooms / 3);
                if (count > 0) {
                    const currentRotation = count - 1;
                    const startIndex = currentRotation * 3;
                    const endIndex = Math.min(startIndex + 3, totalRooms);
                    const roomBatch = selectroom.slice(startIndex, endIndex).join(",");
                    setCount(count - 1);
                    setdisplay(roomBatch);
                    setdisplay1(roomBatch ? roomBatch.split(",")[0] : "");
                    setdisplay2(roomBatch ? (roomBatch.split(",")[1] || "") : ""); // 예외 처리 추가
                    setdisplay3(roomBatch ? (roomBatch.split(",")[2] || "") : ""); // 예외 처리 추가
                    const displayparam1 = roomBatch ? roomBatch.split(",")[0] : "";
                    const displayparam2 = roomBatch ? (roomBatch.split(",")[1] || "") : ""; // 예외 처리 추가
                    const displayparam3 = roomBatch ? (roomBatch.split(",")[2] || "") : ""; // 예외 처리 추가
                    fetchWaitMemberviewDataAPI(displayparam1, displayparam2, displayparam3);
                } else {
                    handleRightButtonClick();
                }
            }
        } catch (error) {

        }


    };

    useEffect(() => {
        // console.log("선택값 리스트  :" + JSON.stringify(waitModalselectvalue))


        if (waitModalselectvalue.차트번호 === null && waitModalselectvalue.회원명 !== null && waitModalselectvalue.회원명.length === 5 && !isNaN(waitModalselectvalue.회원명.slice(0, 3)) && waitModalselectvalue.회원명.slice(4) === "님") {
            // console.log("차트번호가 없으면서 이름이 0000님 인경우");
            setiswaitModallocalname_emp(true)
        } else {
            setiswaitModallocalname_emp(false)
        }


        if (waitModalselectvalue.차트번호 === null && waitModalselectvalue.회원명 !== null && waitModalselectvalue.회원명.length !== 5 && isNaN(waitModalselectvalue.회원명.slice(0, 3)) && waitModalselectvalue.회원명.slice(4) !== "님") {
            // console.log("차트번호가 없으면서 이름이 있는 경우");
            setiswaitMemberModallocalname_emp(true)
        } else {
            setiswaitMemberModallocalname_emp(false)
        }



        // setiswaitMemberModallocalname_emp

    }, [waitModalselectvalue]);
    const handleDateChange = (
        selectedDate: dayjs.Dayjs | null,
        dateString: string,
        index: number
    ) => {
        if (selectedDate) {
            const formattedDate = selectedDate.format("YYYY-MM-DD");
            // console.log("Selected date:", formattedDate);
            setBirthdate(formattedDate);
            // console.log("Birthdate state updated:", formattedDate);

            // 변경된 날짜를 해당 인덱스의 info에 업데이트합니다.
            setFamilyInfo((prevFamilyInfo) => {
                const updatedFamilyInfo = [...prevFamilyInfo];
                updatedFamilyInfo[index] = {
                    ...updatedFamilyInfo[index],
                    birthdate: formattedDate,
                };
                return updatedFamilyInfo;
            });
        } else {
            console.log("No date selected");
        }
    };

    const handleSave = async () => {
        const jsonData: { "서식": Question[] } = { "서식": [] };
        let isDuplicate = false;
        questions.forEach((question, questionIndex) => {

            console.log("확인 : " + answers[questionIndex])
            console.log("확인1 : " + selectionModes[questionIndex])

            let inputArray: { [key: string]: string | boolean }[] = answers[questionIndex]
                .map((answer, index) => ({
                    [answer]: (index === answers[questionIndex].length - 1 && answer === "기타####") ? "false####" : false
                }))
                .reduce((acc: any[], cur) => {
                    const key = Object.keys(cur)[0];
                    if (!acc.some(item => Object.keys(item)[0] === key)) {
                        acc.push(cur);
                    } else {
                        isDuplicate = true; // 중복 발생 시 플래그 설정
                    }
                    return acc;
                }, []);






            let optiontype: 'single' | 'multi' | 'input' = 'input';

            if (type[questionIndex] === "input") {
                inputArray = [{ "value": "" }];
            }
            // 질문 유형 결정
            if (type[questionIndex] === 'single') {
                optiontype = 'single';
            } else if (type[questionIndex] === 'multi') {
                optiontype = 'multi';
            }

            const questionObj: Question = {
                "name": question,
                "input": inputArray,
                "type": optiontype
            };

            console.log(optiontype + "/" + etcAnswers.length)
            if (optiontype !== 'input') {
                const subInputs = etcAnswers.map(etcAnswer => ({ "기타####": "false####" }));
                console.log("기타 : " + JSON.stringify(subInputs, null, 2));
                inputArray.push(...subInputs);
            }

            jsonData["서식"].push(questionObj);
        });

        // 출력된 JSON 객체를 콘솔에 출력

        if (isDuplicate) {
            console.log("중복된 값이 있습니다. 저장이 취소되었습니다.");
            alert("중복된 값이 있습니다. 저장이 취소되었습니다.");
            return; // 중복이면 저장을 취소하고 함수 종료
        } else {
            console.log(JSON.stringify(jsonData, null, 2));
            console.log("Current state of questions:", questions);
            console.log("Current state of answers:", answers);
            console.log("Current state of selectionModes:", selectionModes);

            const requestBody: {
                clubSeq: number;
                deviceId: string;
                deviceName: string;
                agentSetting: string;
            } = {
                clubSeq: selectedClubInfo?.club_seq || 0,
                deviceId: selectformdeviceID,
                deviceName: selectformdeviceName,
                agentSetting: JSON.stringify(jsonData),
            };


            const response1 = await fetch(
                `${API_BASE_URL_ISSUER}/agentsetting`,
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody),
                }
            );
            console.log("변경사항 : " + JSON.stringify(requestBody));
            const data1 = await response1.json();
            if (response1.ok) {
                console.log("data2 : " + JSON.stringify(data1, null, 2));
                fetchWebAgentSettinglist();

            }



            setselectqrdevicename("")
            setEditedPanel(null);
            console.log('저장되었습니다.');
            message.info('저장되었습니다.');
        }



    };
    const handleLastDateChange = (date: dayjs.Dayjs | null) => {
        setlastdate(date); // Dayjs 형식으로 변경된 날짜 상태 업데이트
    };
    const waitmemberhandledispose = () => {
        waitmembertoggleModal();
    }
    const waitmemberhandleConfirm = () => {
        // 대기 기존회원 정보 수정
        // console.log("선택한 정보 :" + JSON.stringify(selectwaitmemberModal, null, 2))
        if ("전화번호" in selectwaitmemberModal) {
            const patchData = {
                clubSeq: selectedClubInfo?.club_seq,
                mobileNumber: selectwaitmemberModal["전화번호"],
                localName: memberwaitlocalname
            };

            // console.log("수정내용" + JSON.stringify(patchData, null, 2))
            // console.log("찾는 전화번호 : " + selectwaitmemberModal["전화번호"])
            // console.log("찾는 데이터 : " + JSON.stringify(waitingrowdata, null, 2))

            const foundData = waitingrowdata
                .filter((item) => item.flag === true)
                .filter((item) => item.invitationMobileNumber === selectwaitmemberModal["전화번호"]);

            if (foundData.length > 0) {
                const invitationClubValid = foundData[0].invitationClubValid;
                // console.log("invitationClubValid 값:", invitationClubValid);


                if (invitationClubValid === false) {


                    fetch(`${API_BASE_URL_ISSUER}/clubmembers/localname`, {
                        method: 'PATCH',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`,
                        },
                        body: JSON.stringify(patchData),
                    })
                        .then(response => {
                            if (!response.ok) {
                                throw new Error('Network response was not ok');
                            }
                            return response.json();
                        })
                        .then(data => {
                        })
                        .catch(error => {
                            console.error('There was an error with the PATCH request:', error);
                        });

                }

            } else {
                console.log("해당하는 데이터를 찾을 수 없습니다.");
            }






            fetch(`${API_BASE_URL_ISSUER}/invitations/localname/extradata`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify(patchData),
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then(data => {
                    // fetchroomDataAPI();
                    console.log("확인!!")
                    const totalRooms = selectroom.length;
                    const rotations = Math.ceil(totalRooms / 3);
                    let currentRotation = 0;
                    fetchWaitinglistDataAPII();
                    setwaitingtabledataArray1([]);
                    setwaitingtabledataArray2([]);
                    setwaitingtabledataArray3([]);
                    setwaittingdataArray1([]);
                    setwaittingdataArray2([]);
                    setwaittingdataArray3([]);
                    setdisplay1(null);
                    setdisplay2(null);
                    setdisplay3(null);
                    const startIndex = currentRotation * 3;
                    const endIndex = Math.min(startIndex + 3, totalRooms);
                    const roomBatch = selectroom.slice(startIndex, endIndex).join(",");
                    if (roomBatch !== "") {
                        setdisplay(roomBatch);
                        setdisplay1(roomBatch ? roomBatch.split(",")[0] : "");
                        setdisplay2(roomBatch && roomBatch.split(",")[1] ? roomBatch.split(",")[1] : "");
                        setdisplay3(roomBatch && roomBatch.split(",")[2] ? roomBatch.split(",")[2] : "");
                    }
                    const displayparam1 = roomBatch ? roomBatch.split(",")[0] : "";
                    const displayparam2 = roomBatch && roomBatch.split(",")[1] ? roomBatch.split(",")[1] : "";
                    const displayparam3 = roomBatch && roomBatch.split(",")[2] ? roomBatch.split(",")[2] : "";
                    console.log("실행3")
                    fetchWaitMemberviewDataAPI(displayparam1, displayparam2, displayparam3);
                    currentRotation = (currentRotation + 1) % rotations;
                    waitmembertoggleModal();

                })
                .catch(error => {
                    console.error('There was an error with the PATCH request:', error);
                });


        } else {
            console.error("전화번호가 존재하지 않습니다.");
        }


    };
    const handleAddQuestion = () => {
        console.log("문항추가")
        const newQuestions: string[] = [...questions, '']; // 새로운 문항 추가
        const newAnswers: any[] = [...answers, []]; // 새로운 문항에 대한 답변 배열 추가
        const types: string[] = [];
        const newSelectionModes: ("single" | "multi" | "input")[] = [...selectionModes, 'single']; // 새로운 문항의 선택 모드 기본값 설정
        const type = "single";
        types.push(type);
        setType(types)
        setQuestions(newQuestions);
        setAnswers(newAnswers);
        setSelectionModes(newSelectionModes);
    };

    const pqrhandleSave = async () => {
        setIsButtonDisabled(true);
        if (newqrdevice == "") {
            alert('이름을 입력해주세요');
        } else {

            const response = await fetch(
                `${API_BASE_URL_ISSUER}/presentation/verifier/name/${selectedClubInfo?.club_seq}/${newqrdevice}`, // URL 문자열
                { // 옵션 객체
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    }
                }
            );

            // 응답이 성공했는지 확인
            if (response.ok) {
                const data = await response.json();
                console.log("데이터확인 : " + JSON.stringify(data, null, 2));

                if (JSON.stringify(data.data.exists, null, 2) == "true") {
                    alert('중복된 이름입니다.');
                } else {
                    const nowformattedDate = new Date().toLocaleString('ko-KR', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).replace(/[^\d]/g, '');
                    console.log("deviceId= tmp_device")
                    console.log("이슈어 디아이 : " + selectdid[0]);
                    console.log("클럽시퀀스 : " + selectedClubInfo?.club_seq);
                    console.log("기기명 : " + newqrdevice);
                    console.log("시간 : " + nowformattedDate);

                    try {

                        const requestBody: {
                            did: string;
                            clubSeq: number;
                            deviceId: string;
                            deviceName: string;
                        } = {
                            did: selectdid[0],
                            clubSeq: selectedClubInfo?.club_seq || 0,
                            deviceId: "tmp_device." + selectdid[0] + "." + selectedClubInfo?.club_seq + "." + nowformattedDate,
                            deviceName: newqrdevice,
                        };

                        const requestBody1: {
                            clubSeq: number;
                            deviceId: string;
                            deviceName: string;
                            agentSetting: string;
                        } = {
                            clubSeq: selectedClubInfo?.club_seq || 0,
                            deviceId: "tmp_device." + selectdid[0] + "." + selectedClubInfo?.club_seq + "." + nowformattedDate,
                            deviceName: newqrdevice,
                            agentSetting: "{\"증상\": [],\"진료실\": []}",
                        };

                        const response = await fetch(
                            `${API_BASE_URL_ISSUER}/presentation/verification/web/devices`,
                            {
                                method: "POST",
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                    "Content-Type": "application/json",
                                },
                                body: JSON.stringify(requestBody),
                            }
                        );
                        console.log("변경사항 : " + JSON.stringify(requestBody));
                        const data = await response.json();
                        if (response.ok) {
                            console.log("data1 : " + JSON.stringify(data, null, 2));
                        }


                        const response1 = await fetch(
                            `${API_BASE_URL_ISSUER}/agentsetting`,
                            {
                                method: "POST",
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                    "Content-Type": "application/json",
                                },
                                body: JSON.stringify(requestBody1),
                            }
                        );
                        console.log("변경사항 : " + JSON.stringify(requestBody));
                        const data1 = await response1.json();
                        if (response1.ok) {
                            console.log("data2 : " + JSON.stringify(data1, null, 2));
                        }

                    } catch (error) {

                    }


                    fetchWebAgentSettinglist();
                    fetchwaitagentSettingDataAPI();
                    setnewqrdevice("")
                }
            }
        }
        setTimeout(() => {
            // 1초 후에 버튼을 다시 활성화합니다.
            setIsButtonDisabled(false);
        }, 1000);
    }
    const qqrhandleSave = async () => {
        setIsButtonDisabled(true);
        if (newqrdevice == "") {
            alert('이름을 입력해주세요');
        } else {

            const response = await fetch(
                `${API_BASE_URL_ISSUER}/presentation/verifier/name/${selectedClubInfo?.club_seq}/${newqrdevice}`, // URL 문자열
                { // 옵션 객체
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    }
                }
            );

            // 응답이 성공했는지 확인
            if (response.ok) {
                const data = await response.json();
                console.log("데이터확인 : " + JSON.stringify(data, null, 2));

                if (JSON.stringify(data.data.exists, null, 2) == "true") {
                    alert('중복된 이름입니다.');
                } else {
                    try {
                        const nowformattedDate = new Date().toLocaleString('ko-KR', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).replace(/[^\d]/g, '');
                        const requestBody: {
                            did: string;
                            clubSeq: number;
                            deviceId: string;
                            deviceName: string;
                        } = {
                            did: selectdid[0],
                            clubSeq: selectedClubInfo?.club_seq || 0,
                            deviceId: "form_device." + selectdid[0] + "." + selectedClubInfo?.club_seq + "." + nowformattedDate,
                            deviceName: newqrdevice,
                        };
                        const requestBody1: {
                            clubSeq: number;
                            deviceId: string;
                            deviceName: string;
                            agentSetting: string;
                            title: string;
                            type: string;
                        } = {
                            clubSeq: selectedClubInfo?.club_seq || 0,
                            deviceId: "form_device." + selectdid[0] + "." + selectedClubInfo?.club_seq + "." + nowformattedDate,
                            deviceName: newqrdevice,
                            agentSetting: "{\"서식\": []}",
                            title: newqrdevice,
                            type: typeselectionMode === 'type1' ? "서식" : "동의서",
                        };

                        const response = await fetch(
                            `${API_BASE_URL_ISSUER}/presentation/verification/web/devices`,
                            {
                                method: "POST",
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                    "Content-Type": "application/json",
                                },
                                body: JSON.stringify(requestBody),
                            }
                        );
                        console.log("변경사항1 : " + JSON.stringify(requestBody));
                        const data = await response.json();
                        if (response.ok) {
                            console.log("data1 : " + JSON.stringify(data, null, 2));
                        }


                        const response1 = await fetch(
                            `${API_BASE_URL_ISSUER}/agentsetting`,
                            {
                                method: "POST",
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                    "Content-Type": "application/json",
                                },
                                body: JSON.stringify(requestBody1),
                            }
                        );
                        console.log("변경사항2 : " + JSON.stringify(requestBody));
                        const data1 = await response1.json();
                        if (response1.ok) {
                            console.log("data2 : " + JSON.stringify(data1, null, 2));
                        }

                    } catch (error) {

                    }


                    fetchWebAgentSettinglist();
                    fetchwaitagentSettingDataAPI();
                    setnewqrdevice("")
                }
            } else {
                console.error("응답이 실패했습니다.");
            }
        }


        setTimeout(() => {
            // 1초 후에 버튼을 다시 활성화합니다.
            setIsButtonDisabled(false);
        }, 1000);

    }

    const waithandledispose = () => {
        waittoggleModal();

    }
    const waithandleConfirm = () => {
        // 대기 신규회원 정보 수정
        if (newwaitlocalname !== "" && newwaitname !== "") {
            if ("전화번호" in selectwaitModal) {
                const patchData = {
                    clubSeq: selectedClubInfo?.club_seq,
                    mobileNumber: selectwaitModal["전화번호"],
                    localName: newwaitlocalname,
                    memberName: newwaitname
                };

                console.log("수정내용" + JSON.stringify(patchData, null, 2))


                fetch(`${API_BASE_URL_ISSUER}/invitations/localname/extradata`, {
                    method: 'PATCH',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                    body: JSON.stringify(patchData),
                })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Network response was not ok');
                        }
                        return response.json();
                    })
                    .then(data => {
                        // fetchroomDataAPI();

                        console.log("확인!!")

                        fetchWaitinglistDataAPII();
                        setwaitingtabledataArray1([]);
                        setwaitingtabledataArray2([]);
                        setwaitingtabledataArray3([]);
                        setwaittingdataArray1([]);
                        setwaittingdataArray2([]);
                        setwaittingdataArray3([]);

                        setdisplay1(null);
                        setdisplay2(null);
                        setdisplay3(null);

                        const totalRooms = selectroom.length;
                        const rotations = Math.ceil(totalRooms / 3);
                        let currentRotation = 0;
                        const startIndex = currentRotation * 3;
                        const endIndex = Math.min(startIndex + 3, totalRooms);
                        const roomBatch = selectroom.slice(startIndex, endIndex).join(",");
                        if (roomBatch !== "") {
                            setdisplay(roomBatch);
                            setdisplay1(roomBatch ? roomBatch.split(",")[0] : "");
                            setdisplay2(roomBatch && roomBatch.split(",")[1] ? roomBatch.split(",")[1] : "");
                            setdisplay3(roomBatch && roomBatch.split(",")[2] ? roomBatch.split(",")[2] : "");
                        }
                        const displayparam1 = roomBatch ? roomBatch.split(",")[0] : "";
                        const displayparam2 = roomBatch && roomBatch.split(",")[1] ? roomBatch.split(",")[1] : "";
                        const displayparam3 = roomBatch && roomBatch.split(",")[2] ? roomBatch.split(",")[2] : "";
                        console.log("실행4")
                        fetchWaitMemberviewDataAPI(displayparam1, displayparam2, displayparam3);
                        currentRotation = (currentRotation + 1) % rotations;
                        waittoggleModal();

                    })
                    .catch(error => {
                        console.error('There was an error with the PATCH request:', error);
                    });

            } else {
                console.error("전화번호가 존재하지 않습니다.");
            }

        }
    };
    const handleCheckboxChange = (value: any) => {
        console.log("Checkbox value:", value);
    };
    const QRhandleAddItem = async (itemName: any, newItemValue: any) => {
        const updatedData = [...webagentsettingrowdata];
        const foundDeviceIndex = updatedData.findIndex((agentSetting) => agentSetting.deviceName === expandedDevice);
        if (foundDeviceIndex !== -1) {
            const currentData = JSON.parse(updatedData[foundDeviceIndex].agentSetting);
            let updatedItemList;

            // 항목이 증상인 경우
            if (itemName === '증상') {
                updatedItemList = [...currentData.증상, { [newItemValue]: true }];
                setNewSymptomInput("");

            }
            if (itemName === '진료실') {
                updatedItemList = [...currentData.진료실, { [newItemValue]: true }];
                setNewRoomInput("");

            }

            // 업데이트된 항목을 다시 문자열로 변환하여 원본 데이터를 업데이트
            updatedData[foundDeviceIndex].agentSetting = JSON.stringify({
                ...currentData,
                [itemName]: updatedItemList
            });

            const updatedDataObject = {
                ...currentData,
                [itemName]: updatedItemList
            };
            console.log("업데이트 이후3 : " + JSON.stringify(updatedDataObject, null, 2))

            console.log("선택중인 종이QR이름 : " + expandedDevice)


            const requestBody1: {
                clubSeq: number;
                deviceId: string;
                deviceName: string;
                agentSetting: string;
            } = {
                clubSeq: selectedClubInfo?.club_seq || 0,
                deviceId: selectdeviceid,
                deviceName: expandedDevice + "",
                agentSetting: JSON.stringify(updatedDataObject),
            };
            console.log("변경사항 : " + JSON.stringify(requestBody1, null, 2));
            const response1 = await fetch(
                `${API_BASE_URL_ISSUER}/agentsetting`,
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody1),
                }
            );

            const data1 = await response1.json();
            if (response1.ok) {
                console.log("data2 : " + JSON.stringify(data1, null, 2));
            }

            // // 상태를 업데이트

            // console.log("최종데이터 : " + JSON.stringify(updatedData,null,2))
            setwebagentsettingrowdata(updatedData);
        }
    };
    const qrprint = async () => {
        if (qrRef.current) {
            const canvas = await html2canvas(qrRef.current);
            const dataUrl = canvas.toDataURL('image/png');

            // 새 창을 열어 이미지를 인쇄
            const printWindow = window.open('', '_blank');
            if (printWindow) {
                printWindow.document.write(`
            <html>
              <head>
                <style>
                  body { 
                    margin: 0; 
                    display: flex; 
                    justify-content: center; 
                    align-items: center; 
                    height: 100vh; 
                    width: 100vw; 
                    overflow: hidden; 
                  }
                  .qr-container {
                    position: absolute;
                    top: 50%;
                    left: 63%;
                    transform: translate(-50%, -50%);
                  }
                  img { 
                    width: 80vw; /* 수정: QR 코드 너비 조정 */
                    height: auto; 
                  }
                  @page { 
                    margin: 0; 
                  }
                </style>
              </head>
              <body>
                <div class="qr-container">
                  <img src="${dataUrl}" onload="window.print();window.close()" />
                </div>
              </body>
            </html>
          `);
                printWindow.document.close();
            }
        }
    };





    const qrcreate = async (methodvalue:String) => {
        console.log("날짜확인1 : " + lastdate);
        const formattedDate = dayjs(lastdate).format('YYYY-MM-DD');
        console.log("날짜확인2 : " + formattedDate);
        console.log("시간확인 : " + Qrlasttimetime);
        const Qrlasttime1 = formattedDate + " " + Qrlasttimetime;

        setQrlasttime(Qrlasttime1)

        if (Qrlasttime1 === "" || !/^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2})$/.test(Qrlasttime1)) {
            console.log("시간 형식이 잘못되었습니다. YYYY-MM-DD HH:mm 형식으로 입력하세요.");
        } else {
            const formattedQrLastTime = Qrlasttime1.replace(" ", "T");
            console.log("1 : " + selectedClubInfo?.club_seq)
            console.log("2 : " + selectdeviceid)
            console.log("3 : " + true)
            console.log("4 : " + formattedQrLastTime)

            const postData = {
                verifierClubSeq: selectedClubInfo?.club_seq,
                deviceId: selectdeviceid,
                method: selectmethodvalue,
                longPeriod: true,
                qrEndTime: formattedQrLastTime,
            };

            console.log("입력값 : " + JSON.stringify(postData));

            const response = await fetch(`${API_BASE_URL_ISSUER}/presentation/verification/qrLinks`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(postData),
            });

            const data = await response.json();
            console.log("(waitinput) PUT 요청 성공:", JSON.stringify(data));
            if (data.code == 200) {
                console.log("qr 핀번호 : " + data.data.qrLinkPin);
                const jsonData = {
                    "pin": data.data.qrLinkPin,
                    "did": selectdid[0],
                    "method": methodvalue
                };

                const jsonString = JSON.stringify(jsonData);

                console.log("qr데이터 : " + JSON.stringify(jsonData));
                if (qrdata === "") {
                    message.info("새QR코드를 생성했습니다.");
                } else {
                    message.info("QR코드 정보를 수정했습니다.");
                }
                setqrdata(jsonString);

            }

        }

    }

    const toggleButton = () => {
        setIsOn(!isOn);
    };
    const handleDeleteItem = async (itemName: any, itemIndex: any) => {
        const updatedData = [...webagentsettingrowdata];
        const foundDeviceIndex = updatedData.findIndex((agentSetting) => agentSetting.deviceName === expandedDevice);
        if (foundDeviceIndex !== -1) {
            const currentData = JSON.parse(updatedData[foundDeviceIndex].agentSetting);
            let updatedItemList;

            // 항목이 증상인 경우
            if (itemName === '증상') {
                updatedItemList = currentData.증상.filter((symptom: any, index: any) => index !== itemIndex);
            }
            // 항목이 진료실인 경우
            else if (itemName === '진료실') {
                updatedItemList = currentData.진료실.filter((room: any, index: any) => index !== itemIndex);
            }

            // 업데이트된 항목을 다시 문자열로 변환하여 원본 데이터를 업데이트
            updatedData[foundDeviceIndex].agentSetting = JSON.stringify({
                ...currentData,
                [itemName]: updatedItemList
            });

            const updatedDataObject = {
                ...currentData,
                [itemName]: updatedItemList
            };
            console.log("업데이트 이후3 : " + JSON.stringify(updatedDataObject, null, 2))

            console.log("선택중인 종이QR이름 : " + expandedDevice)


            const requestBody1: {
                clubSeq: number;
                deviceId: string;
                deviceName: string;
                agentSetting: string;
            } = {
                clubSeq: selectedClubInfo?.club_seq || 0,
                deviceId: selectdeviceid,
                deviceName: expandedDevice + "",
                agentSetting: JSON.stringify(updatedDataObject),
            };
            const response1 = await fetch(
                `${API_BASE_URL_ISSUER}/agentsetting`,
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody1),
                }
            );
            console.log("변경사항 : " + JSON.stringify(requestBody1, null, 2));
            const data1 = await response1.json();
            if (response1.ok) {
                console.log("data2 : " + JSON.stringify(data1, null, 2));
            }

            // // 상태를 업데이트

            // console.log("최종데이터 : " + JSON.stringify(updatedData,null,2))
            setwebagentsettingrowdata(updatedData);
        }
    };
    const handleToggleSymptom = (index: any, symptomName: any, isChecked: any) => {
        const updatedData = [...webagentsettingrowdata];
        const foundDeviceIndex = updatedData.findIndex((agentSetting) => agentSetting.deviceName === expandedDevice);
        if (foundDeviceIndex !== -1) {
            const symptomData = JSON.parse(updatedData[foundDeviceIndex].agentSetting).증상;
            const updatedSymptomData = symptomData.map((symptom: any, idx: any) => {
                if (idx === index) {
                    // 선택한 증상의 값을 변경
                    return { [symptomName]: !isChecked };
                }
                return symptom;
            });
            updatedData[foundDeviceIndex].agentSetting = JSON.stringify({ ...JSON.parse(updatedData[foundDeviceIndex].agentSetting), 증상: updatedSymptomData });
            setwebagentsettingrowdata(updatedData); // 업데이트된 데이터를 상태로 설정
        }
    };

    const handleToggleRoom = (index: any, roomName: any, isChecked: any) => {
        const updatedData = [...webagentsettingrowdata];
        const foundRoomIndex = updatedData.findIndex((agentSetting) => agentSetting.deviceName === expandedDevice);
        if (foundRoomIndex !== -1) {
            const roomData = JSON.parse(updatedData[foundRoomIndex].agentSetting).진료실;
            const updatedRoomData = roomData.map((room: any, idx: any) => {
                if (idx === index) {
                    // 선택한 진료실의 값을 변경
                    return { [roomName]: !isChecked };
                }
                return room;
            });
            updatedData[foundRoomIndex].agentSetting = JSON.stringify({ ...JSON.parse(updatedData[foundRoomIndex].agentSetting), 진료실: updatedRoomData });
            setwebagentsettingrowdata(updatedData); // 업데이트된 데이터를 상태로 설정
        }
    };
    const handlememberClick = (record: any, col: any) => {
        if (!/^\d{4}님$/.test(record.회원명)) {

            tablehandleRowClick(record, col)
            const textToCopy = record.회원명;
            const input = document.createElement("input");
            document.body.appendChild(input);
            input.value = textToCopy;
            input.select();
            document.execCommand("copy");
            document.body.removeChild(input);

            message.info('이름을 복사했습니다. : ' + record.회원명);

        } else {
            waittoggleModal();
        }
    };


    const cookicancel = () => {
        let expiresDate = new Date();
        expiresDate.setTime(expiresDate.getTime() + (365 * 24 * 60 * 60 * 1000));
        let expires = "expires=" + expiresDate.toUTCString();

        document.cookie = "myKey=" + "" + "; " + expires + "; path=/";
        setcookievalue("");
    };

    const cookisave = (deviceName: any) => {
        console.log("저장할값 : " + deviceName);
        let expiresDate = new Date();
        expiresDate.setTime(expiresDate.getTime() + (365 * 24 * 60 * 60 * 1000));
        let expires = "expires=" + expiresDate.toUTCString();

        document.cookie = "myKey=" + deviceName + "; " + expires + "; path=/";

        setcookievalue(deviceName);
        setSelectedDeviceName(deviceName);


    };
    const toggleExpand = (deviceName: any) => {

        setExpandedDevice(expandedDevice === deviceName ? null : deviceName); // 클릭한 기기명에 따라 펼치기/접기 토글
        setEditedPanel(null);
        console.log("gggg")
        console.log("deviceName : " + deviceName)
        console.log("타입 : " + selectmethodvalue)
        if (selectmethodvalue === "SELF-WAITING") {
            const filterlist = webagentsettingrowdata.find(item => item.deviceName === deviceName);
            // console.log("all : " + JSON.stringify(webagentsettingrowdataform,null,2) )
            // deviceQR2가 존재하면 deviceId 출력
            if (filterlist) {
                console.log("있음")
                setselectqrdevicename(filterlist.deviceName)
                setselectdeviceid(filterlist.deviceId)


            } else {
                setselectqrdevicename("")
                setselectdeviceid("")
            }
        } else if (selectmethodvalue === "INPUT-FORM") {
            const filterlist = webagentsettingrowdataform.find(item => item.deviceName === deviceName);
            // console.log("all : " + JSON.stringify(webagentsettingrowdataform,null,2) )
            // deviceQR2가 존재하면 deviceId 출력
            if (filterlist) {
                console.log("있음")
                setselectqrdevicename(filterlist.deviceName)
                setselectdeviceid(filterlist.deviceId)


            } else {
                setselectqrdevicename("")
                setselectdeviceid("")
            }
        }




        if (expandedDevice === deviceName) {
            setselectqrdevicename("")
            setselectdeviceid("")
        }


    };

    const handleQcordClick = (record: any, col: any) => {
        tablehandleRowClick(record, col)
        console.log("Q코드 선택");

        // record.내원증상 값을 가져와서 처리
        const symptom = record.내원증상.trim();
        const parts = symptom.split(',');
        let qCode = '';

        // "Q"로 시작하고 뒤에 12자리 숫자가 오는 부분만 추출
        parts.forEach((part: any) => {
            if (/^Q\d{12}$/.test(part.trim())) {
                qCode = part.trim();
            }
        });

        // 추출한 Q코드를 복사
        if (qCode !== '') {
            const input = document.createElement("input");
            document.body.appendChild(input);
            input.value = qCode;
            input.select();
            document.execCommand("copy");
            document.body.removeChild(input);

            message.info('Q코드를 복사했습니다. : ' + qCode);
        }
    };
    const handleChartNumberClick = (record: any, col: any) => {
        tablehandleRowClick(record, col)
        console.log("차트번호 선택")
        console.log("모달실행!" + JSON.stringify(record));
        console.log("모달실행!" + col);

        console.log("차트번호 : " + record.차트번호)
        if (record.차트번호 !== null) {
            const textToCopy = record.차트번호; // 복사할 텍스트
            const input = document.createElement("input"); // 임시 input 요소 생성
            document.body.appendChild(input); // body에 input 요소 추가
            input.value = textToCopy; // input 요소의 값으로 복사할 텍스트 설정
            input.select(); // input 요소 선택
            document.execCommand("copy"); // 클립보드에 복사
            document.body.removeChild(input); // body에서 input 요소 제거

            message.info('차트번호를 복사했습니다. : ' + record.차트번호);

        }
        // if(record.차트번호)
        waittoggleModal();
        waitmembertoggleModal();

        setselectwaitmemberModalname(record.회원명)
        setselectwaitmemberModal(record)
        setselectwaitModalname(record.회원명)
        setselectwaitModal(record)

        setwaitModalselectvalue(record);

    };
    const handleEdit = (panelName: any, deviceId: string) => {
        if (deviceId.startsWith("tmp_device")) {
            // tmp_device일 경우의 처리 로직
            setEditedPanel(panelName);
            setselectformdeviceID(deviceId);
            setselectformdeviceName(panelName);

            // 추가적인 처리 로직 추가 가능
        } else if (deviceId.startsWith("form_device")) {
            // form_device일 경우의 처리 로직
            setEditedPanel(panelName);
            setselectformdeviceID(deviceId);
            setselectformdeviceName(panelName);

            // form_device일 때 추가적인 처리 로직
            // 예: 기존 값 로드 등
            const agentSetting = webagentsettingrowdataform.find((item: any) => item.deviceId === deviceId);
            if (agentSetting) {
                try {
                    const jsonData = JSON.parse(agentSetting.agentSetting);
                    const questions = jsonData.서식 || []; // 서식 배열이 존재하지 않을 경우 빈 배열로 초기화
                    console.log("서식값 : " + JSON.stringify(questions))
                    const questionNames = questions.map((question: any) => question.name);
                    // 문항 설정
                    setQuestions(questionNames);

                    const answers: string[][] = [];
                    const types: string[] = [];

                    questions.forEach((question: any) => {
                        const inputAnswers = question.input.map((inputItem: any) => Object.keys(inputItem)[0]);
                        const type = question.type;
                        inputAnswers.forEach((answer: any) => {
                            if (answer.endsWith("####")) {
                                console.log("확인 : " + answer);
                            }
                        });
                        types.push(type);
                        answers.push(inputAnswers); // 질문에 해당하는 답변 배열을 설정
                    });

                    setAnswers(answers);
                    setType(types)
                    // setSelectionModes()

                    // setEtcAnswers([...etcAnswers, '']);

                    // 기타 응답 설정
                    const etcAnswers: string[] = [];
                    questions.forEach((question: any) => {
                        if (question.subInput) {
                            Object.keys(question.subInput).forEach(key => {
                                etcAnswers.push(key);
                            });
                        }
                    });
                    setEtcAnswers(etcAnswers);
                } catch (error) {
                    console.error('JSON 파싱 오류:', error);
                    message.error('서식 데이터를 로드하는 도중 오류가 발생했습니다.');
                }
            } else {
                message.error('해당하는 디바이스 설정을 찾을 수 없습니다.');
            }

            // 추가적인 처리 로직 추가 가능
        } else {
            message.error('수정할 수 없는 디바이스입니다.');
        }
    };
    const { confirm } = Modal;
    const QRhandledelete = () => {

        confirm({
            title: 'QR삭제',
            icon: <ExclamationCircleOutlined />,
            content: '정말 삭제하시겠습니까?',
            okText: '삭제',
            okType: 'danger',
            cancelText: '취소',
            onOk() {
                fetch(`${API_BASE_URL_ISSUER}/presentation/qrlinks/${qrLinkSeq}`, {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                    .then((response) => {
                        if (!response.ok) {


                            throw new Error('Network response was not ok ' + response.statusText);
                        }
                        return response.json();
                    })
                    .then((data) => {
                        console.log('Success:', data);
                        setqrdata("");
                        setQrlasttime("");



                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    });
            },
            onCancel() {
                console.log('취소되었습니다.');
            },
        });





    }
    const handledelete = (deviceName: any, deviceId: any) => {

        console.log("삭제할 기기 : " + deviceName);
        console.log("삭제할 클럽 : " + selectedClubInfo?.club_seq);
        console.log("삭제할 아이디 : " + deviceId);


        if (deviceId.split(".")[0] === "tmp_device" || deviceId.split(".")[0] === "form_device") {



            confirm({
                title: "서식 삭제",
                icon: <ExclamationCircleOutlined />,
                content: '정말 삭제하시겠습니까?',
                okText: '삭제',
                okType: 'danger',
                cancelText: '취소',
                onOk() {
                    const postData = {
                        clubSeq: selectedClubInfo?.club_seq,
                        deviceName: deviceName
                    };

                    fetch(`${API_BASE_URL_ISSUER}/device`, {
                        method: "DELETE",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(postData)
                    })
                        .then((response) => {
                            if (!response.ok) {


                                throw new Error('Network response was not ok ' + response.statusText);
                            }
                            return response.json();
                        })
                        .then((data) => {
                            console.log('Success:', data);
                            fetchWebAgentSettinglist();
                            fetchwaitagentSettingDataAPI();


                        })
                        .catch((error) => {
                            console.error('Error:', error);
                        });
                },
                onCancel() {
                    console.log('취소되었습니다.');
                },
            });




        } else {
            message.error('삭제할수없습니다.');
        }



    }
    const qrRef = useRef<HTMLDivElement>(null);

    const handleQRClick = async () => {
        if (qrRef.current) {
            const canvas = await html2canvas(qrRef.current);
            canvas.toBlob(async (blob) => {
                if (blob) {
                    const item = new ClipboardItem({ 'image/png': blob });
                    await navigator.clipboard.write([item]);
                    message.info("QR 코드 이미지가 클립보드에 복사되었습니다!")
                }
            });
        }
    };
    const handleTimeChange = (time: any, timeString: any) => {
        setQrlasttimetime(timeString); // qrlasttime 상태 업데이트
    };
    const handlejuminNumberClick = (record: any, col: any) => {
        console.log("주민 모달 : " + record.수진자확인)

        setselectwaitmemberModalname(record.회원명)
        setselectwaitmemberModal(record)
        setselectwaitModalname(record.회원명)
        setselectwaitModallocalname(record.차트번호)
        setselectwaitModalphonenumber(record.전화번호)
        setselectwaitModal(record)
        setselectholderid(JSON.stringify(waitingrowdata1.filter(item => item.invitationMobileNumber === record.전화번호).map(item => item.memberId), null, 2))

        const result = waitingrowdata1.filter(item => item.invitationMobileNumber === record.전화번호);

        if (result.length > 0) {


            setselectclubviled(result[0].invitationClubValid)
        } else {
            console.log("해당하는 데이터가 없습니다.");
        }


        // setselectclubviled(JSON.stringify(waitingrowdata1.filter(item => item.invitationMobileNumber === record.전화번호).map(item => item.invitationClubValid), null, 2))


        setwaitModalselectvalue(record)
        waitjuminNumbertoggleModal();
    };


    const handleFamilyClick = (record: any, col: any) => {
        console.log("가족 모달")
        console.log("모달실행!" + JSON.stringify(record));
        console.log("선택한 전화번호!" + record["전화번호"]);
        setFamilyInfo([]);
        setselectfamilymodalphonenumber(record["전화번호"])
        setselectfamilymodalname(record["회원명"])






        fetch(
            `${API_BASE_URL}/club/member/list/${selectedClubInfo?.club_seq}?page=0&size=20000&sort=clubMemberSeq,desc`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        )
            .then((response) => response.json())
            .then((data) => {
                console.log("가족 선택한 전체정보 : " + JSON.stringify(data.data.content, null, 2));

                const matchingMember = data.data.content.find(
                    (member: any) => member.mobileNumber === record["전화번호"]
                );
                console.log("선택 로우" + JSON.stringify(matchingMember, null, 2));
                // console.log("선택한 클럽맴버시퀀스" + JSON.stringify(matchingMember.clubMemberSeq))


                if (matchingMember) { //회원
                    setselectclubMemberSeq(parseInt(matchingMember.clubMemberSeq, 10));
                    console.log("선택한 회원의 번호 :" + parseInt(matchingMember.clubMemberSeq, 10))
                    // Extract extraData from the matching member
                    const extraData = JSON.parse(matchingMember.extraData);
                    if (extraData && extraData.가족 !== undefined) {
                        console.log("회원이고 가족있음");
                        console.log("Extra Data:", extraData.가족);
                        console.log("Extra Datacount:", extraData.가족.length);

                        const numberOfItems = extraData.가족.length;

                        if (!isNaN(numberOfItems)) {
                            const initialFamilyInfo = extraData.가족.map(
                                (familyMember: any) => ({
                                    relationship: familyMember.관계 || "",
                                    name: familyMember.이름 || "",
                                    gender: familyMember.성별 || "",
                                    birthdate: familyMember.생년월일 || "",
                                    chartNumber: familyMember.차트번호 || "",
                                })
                            );
                            setisselectmember(true)
                            setFamilyInfo(initialFamilyInfo);

                        }
                    } else {//가족없음




                        console.log("가족없음");
                        setisselectmember(true);
                        setFamilyInfo([]);



                    }
                } else { //비회원

                    const filteredList = waitingdata.filter(item => item.전화번호 === record["전화번호"]);
                    console.log("가져온 대기리스트 : " + JSON.stringify(filteredList, null, 2));

                    let isfamily = false;

                    filteredList.forEach(item => {
                        const hasFamilyData = item.가족 && item.가족.length > 0;

                        if (hasFamilyData) {
                            isfamily = true;
                        }
                    });

                    if (isfamily) {
                        console.log("비회원이고 가족있음");


                        const familyDataList = filteredList.filter(item => item.가족 && item.가족.length > 0).map(item => item.가족);
                        console.log("Extra Data1:", familyDataList[0]);
                        console.log("Extra Datacount:", familyDataList.length);

                        const numberOfItems = familyDataList[0].length;

                        if (!isNaN(numberOfItems)) {
                            const initialFamilyInfo = familyDataList[0].flat(2).map((familyMember: any) => ({
                                relationship: familyMember.관계 || "",
                                name: familyMember.이름 || "",
                                gender: familyMember.성별 || "",
                                birthdate: familyMember.생년월일 || "",
                                chartNumber: familyMember.차트번호 || "",
                            }));

                            console.log("새로운 가족 정보 : " + JSON.stringify(initialFamilyInfo, null, 2))
                            setisselectmember(false)
                            setFamilyInfo(initialFamilyInfo);

                        }
                    } else {
                        console.log("비회원이고 가족없음");
                        setisselectmember(false);
                        setFamilyInfo([]);
                    }




                }
            })

        // Open the modal

        //   if (coords.col  === 5) {

        //     setIsModalVisible(true);
        //   }

        // } else {
        //   console.log("Invalid clickedRow:", clickedRow);
        // }



        waitfamilytoggleModal();


        // waitmembertoggleModal();

        // setselectwaitmemberModalname(record.회원명)
        // setselectwaitmemberModal(record)
        // setselectwaitModalname(record.회원명)
        // setselectwaitModal(record)

    };

    const tablehandleRowClick = (record: any, col: any) => {

        console.log("Selected Row Values:", record);
        setSelectedRowKey(record.key === selectedRowKey ? null : record.key);

        const firstElement = record.대기번호; // First element
        const secondElement = record.회원명; // Second element
        const thirdElement = record.전화번호; // Third element
        const fourthElement = record.차트번호; // Third element

        setfirstElement(firstElement || "대기번호");
        setsecondElement(secondElement || "회원명");
        setthirdElement(thirdElement || "휴대번호");
        setfourthElement(fourthElement || "차트번호");
    };
    const PQrtoggleModal = () => {
        setSelectMethodValue(selectedClubInfo?.agentSeq === 1 ? "SELF-WAITING" : selectedClubInfo?.agentSeq === 3 ? "RECEPTION" : "");
        setPQrModalOpen(!PQrmodalOpen);
        if (!PQrmodalOpen == false) {
            setExpandedDevice(null);
            setEditedPanel(null);
        }

    };
    const QQrtoggleModal = () => {
        setSelectMethodValue("INPUT-FORM")
        setQQrModalOpen(!QQrmodalOpen);
        if (!QQrmodalOpen == false) {
            setExpandedDevice(null);
            setEditedPanel(null);
        }

    };

    const QrprinttoggleModal = async (methodvalue: any) => {
        setqrprintmodalOpen(!qrprintmodalOpen);
        if (!qrprintmodalOpen) {

            console.log("입력 method : " + methodvalue)

            const requestBody: {
                clubSeq: number;
                deviceId: string;
                method: any;
                longPeriod: boolean;
            } = {
                clubSeq: selectedClubInfo?.club_seq || 0,
                deviceId: selectdeviceid,
                method: methodvalue,
                longPeriod: true,
            };
            const response = await fetch(
                `${API_BASE_URL_ISSUER}/presentation/qrlinks`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody),
                }
            );
            console.log("조회 : " + JSON.stringify(requestBody));
            const data = await response.json();


            if (response.ok) {
                console.log("내역 : " + JSON.stringify(data, null, 2))

                const jsonData = {
                    "pin": data.data.qrLinkPin,
                    "did": selectdid[0],
                    "method": methodvalue
                };

                const jsonString = JSON.stringify(jsonData);

                console.log("qr데이터 : " + JSON.stringify(jsonData));
                setqrdata(jsonString);
                setQrlasttime(data.data.qrEndTime)
                setQrlasttimetime(data.data.qrEndTime.split(" ")[1])
                setlastdate(data.data.qrEndTime.split(" ")[0])
                console.log("날짜확인1 : " + data.data.qrEndTime.split(" ")[0]);
                setqrLinkSeq(data.data.qrLinkSeq)

            } else {
                setqrdata("");
                const timeString = "20:00"; // 예시로 제공된 시간 문자열
                const isValidTime = /^[0-2][0-9]:[0-5][0-9]$/.test(timeString);

                if (isValidTime) {
                    setQrlasttimetime(timeString);
                } else {
                    console.error("유효하지 않은 시간 형식입니다.");
                }
                setqrLinkSeq("");
                const futureDate = dayjs().add(364, 'day').format('YYYY-MM-DD');
                setlastdate(dayjs(futureDate));
                console.log("날짜확인2 : " + futureDate);
            }


        } else {
            setqrdata("");

            const timeString = "20:00"; // 예시로 제공된 시간 문자열
            const isValidTime = /^[0-2][0-9]:[0-5][0-9]$/.test(timeString);

            if (isValidTime) {
                const newQrlasttime = `${Qrlasttime.split(' ')[0]} ${timeString}`;
                setQrlasttimetime(newQrlasttime);
            } else {
                console.error("유효하지 않은 시간 형식입니다.");
            }
            setqrLinkSeq("");
            const futureDate = dayjs().add(364, 'day').format('YYYY-MM-DD');
            console.log("날짜확인3 : " + futureDate);
            setlastdate(dayjs(futureDate));
        }


    };
    const waittoggleModal = () => {
        setwaitModalOpen(!waitmodalOpen);
    };
    const waitfamilytoggleModal = () => {
        setIsModalVisible(!isModalVisible)
    };


    const waitjuminNumbertoggleModal = () => {
        setIsModalVisible2(!isModalVisible2)
    };

    const handleModeChange = (event: React.ChangeEvent<HTMLInputElement>, questionIndex: number) => {
        const newMode = event.target.value; // 클릭된 라디오 버튼의 값(single, multi, input)
        const newTypes = [...type]; // 기존 type 배열을 복사하여 새로운 배열 생성
        newTypes[questionIndex] = newMode; // 선택된 questionIndex의 모드를 업데이트
        setType(newTypes); // 새로운 모드 배열로 상태 업데이트
    };
    const typehandleModeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        settypeSelectionMode(event.target.value as 'type1' | 'type2');
        settypeSelectedItems([]); // Clear selection when mode changes
    };

    const waitmembertoggleModal = () => {

        setwaitmemberModalOpen(!waitmembermodalOpen);
    };
    const viewcolumns = [
        {
            title: "대기번호",
            dataIndex: "waitnumber",
            key: "waitnumber",
            width: "35%",
        },
        {
            title: "회원명",
            dataIndex: "membername",
            key: "membername",
            width: "65%",
        },
    ];
    const columns = [
        {
            title: "대기번호",
            dataIndex: "대기번호",
            key: "대기번호",
            width: "8%",
            titleStyle: { backgroundColor: "#FAFAFA" },
        },
        {
            title: "차트번호",
            dataIndex: "차트번호",
            key: "차트번호",
            width: "8%",
            titleStyle: { backgroundColor: "#FAFAFA" },
        },
        {
            title: "회원명",
            dataIndex: "회원명",
            key: "회원명",
            width: "10%",
            titleStyle: { backgroundColor: "#FAFAFA" },
        },

        {
            title: "내원증상",
            dataIndex: "내원증상",
            key: "내원증상",
            width: "10%",
            titleStyle: { backgroundColor: "#FAFAFA" },
        },
        {
            title: "진료실",
            dataIndex: "진료실",
            key: "진료실",
            width: "15%",
            titleStyle: { backgroundColor: "#FAFAFA" },
        },
        {
            title: "전화번호",
            dataIndex: "전화번호",
            key: "전화번호",
            width: "10%",
            titleStyle: { backgroundColor: "#FAFAFA" },
        },
        {
            title: "가족",
            dataIndex: "가족",
            key: "가족",
            width: "10%",
            titleStyle: { backgroundColor: '#FAFAFA' },

        },

        {
            title: "수진자확인",
            dataIndex: "수진자확인",
            key: "수진자확인",
            width: "14%",
            titleStyle: { backgroundColor: "#FAFAFA" },
        },
        {
            title: "접수시간",
            dataIndex: "접수시간",
            key: "접수시간",
            width: "14%",
            titleStyle: { backgroundColor: "#FAFAFA" },
        },
    ];

    const columns1 = [
        {
            title: "대기번호",
            dataIndex: "대기번호",
            key: "대기번호",
            width: "8%",
            titleStyle: { backgroundColor: "#FAFAFA" },
        },
        {
            title: "차트번호",
            dataIndex: "차트번호",
            key: "차트번호",
            width: "8%",
            titleStyle: { backgroundColor: "#FAFAFA" },
        },
        {
            title: "회원명",
            dataIndex: "회원명",
            key: "회원명",
            width: "10%",
            titleStyle: { backgroundColor: "#FAFAFA" },
        },

        {
            title: "내원증상",
            dataIndex: "내원증상",
            key: "내원증상",
            width: "10%",
            titleStyle: { backgroundColor: "#FAFAFA" },
        },
        {
            title: "진료실",
            dataIndex: "진료실",
            key: "진료실",
            width: "15%",
            titleStyle: { backgroundColor: "#FAFAFA" },
        },
        {
            title: "전화번호",
            dataIndex: "전화번호",
            key: "전화번호",
            width: "10%",
            titleStyle: { backgroundColor: "#FAFAFA" },
        },
        {
            title: "가족",
            dataIndex: "가족",
            key: "가족",
            width: "10%",
            titleStyle: { backgroundColor: '#FAFAFA' },

        },

        {
            title: "수진자확인",
            dataIndex: "수진자확인",
            key: "수진자확인",
            width: "14%",
            titleStyle: { backgroundColor: "#FAFAFA" },
        },
        {
            title: "접수시간",
            dataIndex: "접수시간",
            key: "접수시간",
            width: "14%",
            titleStyle: { backgroundColor: "#FAFAFA" },
        },
    ];

    return (

        <div>

            <div
                style={{
                    width: "100%",
                    // height: width <= 1600 ? "500px" : "600px",
                    height: "100vh",
                    // backgroundColor:"black",
                    display: "flex",
                    padding: "20px"

                }}
            >

                {isModalVisible2 && (

                    <Modal
                        title="수진자 정보 확인"
                        style={{ fontSize: "18px", borderRadius: "20px" }}
                        open={isModalVisible2}
                        onCancel={() => setIsModalVisible2(false)}
                        width={800}
                        footer={[
                            <div key="button-container" style={{ textAlign: "center" }}>
                                <Button
                                    key="confirm"
                                    type="primary"
                                    onClick={juminNumberhandleConfirm}
                                    style={{
                                        width: "220px",
                                        height: "56px",
                                        borderRadius: "20px",
                                        color: "#fff",
                                        background: "#2D5478",
                                        borderColor: "#2D5478",
                                    }}
                                >
                                    저장
                                </Button>
                            </div>,
                        ]}
                    >
                        <div style={{ marginBottom: "16px" }}>
                            <div style={{ display: "flex", marginBottom: "8px" }}>
                                <div style={{ marginRight: "8px", width: "300px" }}>이름</div>
                                <div style={{ marginRight: "8px", width: "300px" }}>주민번호</div>
                            </div>

                            <div style={{ display: "flex", marginBottom: "8px" }}>

                                <Input
                                    readOnly
                                    value={selectwaitModalname}
                                    onChange={waitnamehandleInputChange}

                                    style={{ marginRight: "8px", width: "300px" }}
                                />
                                <Input
                                    placeholder="주민번호"
                                    // value={info.chartNumber}
                                    onChange={waitjunminNumberhandleInputChange}
                                    style={{ marginRight: "8px", width: "300px" }}
                                />
                            </div>
                        </div>
                    </Modal>

                )}

                {isModalVisible && (

                    <Modal
                        title="가족정보 수정"
                        style={{ fontSize: "18px", borderRadius: "20px" }}
                        open={isModalVisible}
                        onCancel={() => setIsModalVisible(false)}
                        width={800}
                        footer={[
                            <div key="button-container" style={{ textAlign: "center" }}>
                                <Button
                                    key="confirm"
                                    type="primary"
                                    onClick={handleConfirm}
                                    style={{
                                        width: "220px",
                                        height: "56px",
                                        borderRadius: "20px",
                                        color: "#fff",
                                        background: "#2D5478",
                                        borderColor: "#2D5478",
                                    }}
                                >
                                    저장
                                </Button>
                            </div>,
                        ]}
                    >
                        <div style={{ marginBottom: "16px" }}>
                            {/* Headers */}
                            <div style={{ display: "flex", marginBottom: "8px" }}>
                                <div style={{ marginRight: "8px", width: "150px" }}>관계</div>
                                <div style={{ marginRight: "8px", width: "150px" }}>이름</div>
                                <div style={{ marginRight: "8px", width: "150px" }}>성별</div>
                                <div style={{ marginRight: "8px", width: "150px" }}>생년월일</div>
                                <div style={{ marginRight: "8px", width: "150px" }}>차트번호</div>
                            </div>
                            {/* Input fields */}
                            {familyInfo.map((info, index) => (
                                <div key={index} style={{ display: "flex", marginBottom: "8px" }}>
                                    <Select
                                        value={info.relationship}
                                        placeholder="부모"
                                        defaultValue={null}
                                        onChange={(value: any) =>
                                            handlerelationshipChange(value, "relationship", index)
                                        }
                                        style={{ width: "100%", marginRight: "8px" }}
                                    >
                                        <Option value="부모">부모</Option>
                                        <Option value="자녀">자녀</Option>
                                        <Option value="기타">기타</Option>
                                    </Select>
                                    <Input
                                        placeholder="이름"
                                        value={info.name}
                                        onChange={(e) => handleInputChange(e, "name", index)}
                                        style={{ marginRight: "8px" }}
                                    />
                                    <Select
                                        value={info.gender}
                                        onChange={(value: any) =>
                                            handleGenderChange(value, "gender", index)
                                        }
                                        style={{ width: "100%", marginRight: "8px" }}
                                    >
                                        <Option value="남">남</Option>
                                        <Option value="여">여</Option>
                                        <Option value="기타">기타</Option>
                                    </Select>
                                    <DatePicker
                                        clearIcon
                                        placeholder="생년월일 선택"
                                        value={
                                            info.birthdate
                                                ? dayjs(info.birthdate)
                                                : birthdate
                                                    ? dayjs(birthdate)
                                                    : null
                                        }
                                        onChange={(date, dateString) =>
                                            handleDateChange(date, dateString, index)
                                        }
                                        style={{ marginRight: "8px", width: "100%" }}
                                        defaultPickerValue={dayjs('1980-01-01')}

                                    />
                                    {/* </div> */}
                                    <Input
                                        placeholder="차트번호"
                                        value={info.chartNumber}
                                        onChange={(e) => handleInputChange(e, "chartNumber", index)}
                                        style={{ marginRight: "8px" }}
                                    />
                                    <Button
                                        onClick={() => handleRemoveItem(index)}
                                        style={{ width: "32px" }}
                                    >
                                        -
                                    </Button>
                                </div>
                            ))}
                            <Button
                                type="primary"
                                style={{ width: "100%", marginBottom: "8px" }}
                                onClick={handleAddItem}
                            >
                                + 추가
                            </Button>
                        </div>
                    </Modal>

                )}


                {QQrmodalOpen && (
                    <div>
                        {/* 모달 */}
                        <Modal
                            title="서식 관리"
                            style={{ fontSize: "18px", borderRadius: "20px" }}
                            open={QQrmodalOpen}
                            onCancel={QQrtoggleModal}
                            width={600}
                            footer={[]} // footer는 빈 배열로 설정하여 하단에 버튼을 따로 추가합니다.
                        >
                            {/* 기기등록 파트 */}
                            <div style={{ marginBottom: "16px", borderBottom: "1px solid black", padding: "16px" }}>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px" }}>
                                    <div style={{ fontWeight: "bold", marginRight: "8px", width: "100px" }}>
                                        서식 제목
                                    </div>
                                    <Input
                                        value={newqrdevice}
                                        onChange={qrdevicehandleInputChange}
                                        style={{ flex: "1" }}
                                    />
                                </div>

                                <div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
                                    <div style={{ fontWeight: "bold", marginRight: "8px", width: "100px" }}>
                                        타입
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <label style={{ marginRight: '20px', fontWeight: 'bold' }}>
                                            <input
                                                type="radio"
                                                value="type1"
                                                checked={typeselectionMode === 'type1'}
                                                onChange={typehandleModeChange}
                                            />
                                            문진
                                        </label>
                                        <label style={{ marginRight: '20px', fontWeight: 'bold' }}>
                                            <input
                                                type="radio"
                                                value="type2"
                                                checked={typeselectionMode === 'type2'}
                                                onChange={typehandleModeChange}
                                            />
                                            동의서
                                        </label>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <Button
                                        key="confirm"
                                        type="primary"
                                        onClick={pqrhandleSave}
                                        style={{
                                            width: "120px",
                                            height: "36px",
                                            borderRadius: "10px",
                                            color: "#fff",
                                            background: "#2D5478",
                                            borderColor: "#2D5478",
                                        }}
                                        disabled={isButtonDisabled}
                                    >
                                        등록
                                    </Button>
                                </div>
                            </div>



                            {webagentsettingrowdataform.sort((a: any, b: any) => new Date(b.created).getTime() - new Date(a.created).getTime())
                                .filter((agentSetting: any) => agentSetting.deviceId.startsWith("form"))
                                .map((agentSetting: any, index: any) => (
                                    <div key={index} style={{ marginBottom: "16px" }}>
                                        <div style={{ marginBottom: "16px", padding: "8px", border: "1px solid #e0e0e0", borderRadius: "8px" }}>
                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px", cursor: 'pointer' }} onClick={() => toggleExpand(agentSetting.deviceName)}>
                                                <div style={{ fontWeight: "bold" }}>{agentSetting.deviceName}</div>



                                                {/*  */}
                                            </div>
                                            {expandedDevice === agentSetting.deviceName && editedPanel !== agentSetting.deviceName && (
                                                <>
                                                    <div style={{ marginBottom: "8px" }}>
                                                        {/* <div style={{ fontWeight: "bold" }}>문항 </div>
                                                        {JSON.parse(agentSetting.agentSetting).서식
                                                            .filter((symptom: any) => Object.values(symptom)[0]) // Filter only true values
                                                            .map((symptom: any, index: any) => (
                                                                <span key={index}>{index > 0 ? ', ' : ''}{Object.keys(symptom)[0]}</span>
                                                            ))} */}
                                                    </div>

                                                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "8px" }}>

                                                        {agentSetting.deviceId.split(".")[0] === "form_device" && (
                                                            <div>
                                                                <Button type="primary" style={{ marginRight: "8px" }} onClick={() => QrprinttoggleModal("INPUT-FORM")}>서식 QR 관리</Button>
                                                                <Button type="primary" style={{ marginRight: "8px" }} onClick={() => handleEdit(agentSetting.deviceName, agentSetting.deviceId)}>
                                                                    수정
                                                                </Button>
                                                                <Button danger onClick={() => handledelete(agentSetting.deviceName, agentSetting.deviceId)}>
                                                                    삭제
                                                                </Button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </>
                                            )}











                                            {
                                                expandedDevice === agentSetting.deviceName && editedPanel === agentSetting.deviceName && (
                                                    <div>
                                                        {
                                                            expandedDevice === agentSetting.deviceName && editedPanel === agentSetting.deviceName && (
                                                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                                    {questions.map((question, questionIndex) => (
                                                                        <div key={questionIndex} style={{ border: '1px solid gray', padding: '10px', marginBottom: '16px' }}>
                                                                            {/* 문항 입력 */}
                                                                            <div style={{ marginBottom: '8px', display: 'flex', alignItems: 'center' }}>
                                                                                <div style={{ fontWeight: 'bold', marginRight: '8px' }}>문항</div>
                                                                                <Input
                                                                                    placeholder="문항을 입력해주세요."
                                                                                    style={{ flex: 1, marginRight: '8px', width: '215px' }}
                                                                                    value={question}
                                                                                    onChange={(e) => {
                                                                                        const newQuestions = [...questions];
                                                                                        newQuestions[questionIndex] = e.target.value;
                                                                                        setQuestions(newQuestions);
                                                                                    }}
                                                                                />
                                                                            </div>



                                                                            {/* 답변 입력 */}
                                                                            <div style={{ marginBottom: '8px', display: 'flex', flexDirection: 'column' }}>
                                                                                <div style={{ marginBottom: '8px' }}>답변</div>

                                                                                {type[questionIndex] === 'input' ? (
                                                                                    <div key={index} style={{ marginBottom: '8px', display: 'flex', alignItems: 'center' }}>
                                                                                        <Input
                                                                                            placeholder="단답형"
                                                                                            style={{ marginRight: '8px', width: '300px' }}
                                                                                            value="단답형" // 수정할 수 없는 상태로 표시
                                                                                            disabled // 수정 불가능하도록 설정
                                                                                        />
                                                                                    </div>
                                                                                ) : (
                                                                                    answers[questionIndex].map((answer: any, answerIndex: any) => (
                                                                                        <div key={answerIndex} style={{ marginBottom: '8px', display: 'flex', alignItems: 'center' }}>
                                                                                            {answer.endsWith('####') ? (
                                                                                                <div key={index} style={{ marginBottom: '8px', display: 'flex', alignItems: 'center' }}>
                                                                                                    <Input
                                                                                                        placeholder="기타..."
                                                                                                        style={{ marginRight: '8px', width: '300px' }}
                                                                                                        value="기타..." // 수정할 수 없는 상태로 표시
                                                                                                        disabled // 수정 불가능하도록 설정
                                                                                                    />
                                                                                                    <Button
                                                                                                        type="primary"
                                                                                                        shape="circle"
                                                                                                        style={{ width: "40px", height: "40px" }}
                                                                                                        icon={<MinusOutlined />}
                                                                                                        onClick={() => handleRemoveAnswer(questionIndex, answerIndex, "etcanswer")}
                                                                                                    />
                                                                                                </div>
                                                                                            ) : (
                                                                                                <>
                                                                                                    <Input
                                                                                                        placeholder="답변을 입력해주세요."
                                                                                                        style={{ marginRight: '8px', width: '300px' }}
                                                                                                        value={answer}
                                                                                                        onChange={(e) => handleAnswerChange(e, questionIndex, answerIndex)}
                                                                                                    />
                                                                                                    <Button
                                                                                                        type="primary"
                                                                                                        shape="circle"
                                                                                                        style={{ width: "40px", height: "40px" }}
                                                                                                        icon={<MinusOutlined />}
                                                                                                        onClick={() => handleRemoveAnswer(questionIndex, answerIndex, "answer")}
                                                                                                    />
                                                                                                </>
                                                                                            )}
                                                                                        </div>
                                                                                    ))
                                                                                )}


                                                                                {type[questionIndex] === 'input' ? (
                                                                                    <span></span>
                                                                                ) : (
                                                                                    <div>
                                                                                        <div
                                                                                            onClick={() => handleAddAnswer(questionIndex, "answer")}
                                                                                            style={{
                                                                                                cursor: 'pointer',
                                                                                                marginRight: '8px',
                                                                                                height: '40px',
                                                                                                marginLeft: '30px',
                                                                                                marginBottom: '30px',
                                                                                                display: 'inline-flex',
                                                                                                color: "gray",
                                                                                                alignItems: 'center',
                                                                                                justifyContent: 'center',
                                                                                            }}
                                                                                        >
                                                                                            답변 추가
                                                                                        </div>
                                                                                        또는
                                                                                        <div
                                                                                            onClick={() => handleAddAnswer(questionIndex, "etcanswer")}

                                                                                            style={{
                                                                                                cursor: 'pointer',
                                                                                                marginRight: '8px',
                                                                                                height: '40px',
                                                                                                marginLeft: '10px',
                                                                                                marginBottom: '30px',
                                                                                                display: 'inline-flex',
                                                                                                color: "blue",
                                                                                                alignItems: 'center',
                                                                                                justifyContent: 'center',
                                                                                            }}
                                                                                        >
                                                                                            '기타' 추가
                                                                                        </div>

                                                                                    </div>
                                                                                )}

                                                                                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>

                                                                                    <label style={{ marginRight: '20px', fontWeight: 'bold' }}>
                                                                                        <input
                                                                                            type="radio"
                                                                                            value="single"
                                                                                            checked={type[questionIndex] === 'single'}
                                                                                            onChange={(e) => handleModeChange(e, questionIndex)}
                                                                                        />
                                                                                        단일선택
                                                                                    </label>
                                                                                    <label style={{ marginRight: '20px', fontWeight: 'bold' }}>
                                                                                        <input
                                                                                            type="radio"
                                                                                            value="multi"
                                                                                            checked={type[questionIndex] === 'multi'}
                                                                                            onChange={(e) => handleModeChange(e, questionIndex)}
                                                                                        />
                                                                                        다중선택
                                                                                    </label>
                                                                                    <label style={{ marginRight: '20px', fontWeight: 'bold' }}>
                                                                                        <input
                                                                                            type="radio"
                                                                                            value="input"
                                                                                            checked={type[questionIndex] === 'input'}
                                                                                            onChange={(e) => handleModeChange(e, questionIndex)}
                                                                                        />
                                                                                        단답형
                                                                                    </label>
                                                                                </div>

                                                                                {/* 저장 버튼 */}
                                                                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                                                    <Button
                                                                                        type="primary"
                                                                                        style={{ width: '120px', height: '36px' }}
                                                                                        onClick={handleSave}
                                                                                    >
                                                                                        저장
                                                                                    </Button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}

                                                                    {/* 문항 추가 버튼 */}
                                                                    <div style={{ display: 'grid', placeItems: 'center' }}>
                                                                        <Button
                                                                            type="primary"
                                                                            shape="circle"
                                                                            icon={<PlusOutlined />}
                                                                            onClick={handleAddQuestion} // 문항 추가 버튼 클릭 시 처리하는 함수
                                                                            style={{ marginRight: '8px', marginTop: "30px", width: '40px', height: '40px', marginBottom: "30px" }}
                                                                        />
                                                                    </div>

                                                                    {/* 답변 입력 방식 선택 */}

                                                                </div>
                                                            )}
                                                    </div>
                                                )
                                            }







                                        </div>
                                    </div>
                                ))}

                        </Modal>
                    </div>
                )}

                {PQrmodalOpen && (
                    <div>
                        {/* 모달 */}
                        <Modal
                            title="진료과 관리"
                            style={{ fontSize: "18px", borderRadius: "20px" }}
                            open={PQrmodalOpen}
                            onCancel={PQrtoggleModal}
                            width={600}
                            footer={[]} // footer는 빈 배열로 설정하여 하단에 버튼을 따로 추가합니다.
                        >
                            {/* 기기등록 파트 */}
                            <div style={{ marginBottom: "16px", borderBottom: "1px solid black", padding: "16px" }}>
                                <div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
                                    <div style={{ fontWeight: "bold", marginRight: "8px", flex: "1" }}>이름</div>
                                    <Input
                                        // placeholder={selectwaitModalname}
                                        value={newqrdevice}
                                        onChange={qrdevicehandleInputChange}
                                        style={{ flex: "2" }}
                                    />
                                    <Button
                                        key="confirm"
                                        type="primary"
                                        onClick={pqrhandleSave}
                                        style={{
                                            width: "120px",
                                            height: "36px",
                                            borderRadius: "10px",
                                            color: "#fff",
                                            background: "#2D5478",
                                            borderColor: "#2D5478",
                                            marginLeft: "16px" // 버튼과 입력칸 사이에 간격 추가
                                        }}
                                        disabled={isButtonDisabled}
                                    >
                                        등록
                                    </Button>
                                </div>
                            </div>

                            {webagentsettingrowdata.sort((a: any, b: any) => new Date(b.created).getTime() - new Date(a.created).getTime())
                                .filter((agentSetting: any) => !agentSetting.deviceId.startsWith("form"))
                                .map((agentSetting: any, index: any) => (
                                    <div key={index} style={{ marginBottom: "16px" }}>
                                        <div style={{ marginBottom: "16px", padding: "8px", border: "1px solid #e0e0e0", borderRadius: "8px" }}>
                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px", cursor: 'pointer' }} onClick={() => toggleExpand(agentSetting.deviceName)}>
                                                <div style={{ fontWeight: "bold" }}>{agentSetting.deviceName}</div>
                                                {cookievalue !== agentSetting.deviceName ? (
                                                    <FaRegStar
                                                        style={{
                                                            marginLeft: '8px',
                                                            fontSize: '24px',
                                                            color: "white",
                                                            stroke: "black",
                                                            strokeWidth: "3px"
                                                        }}
                                                        onClick={() => cookisave(agentSetting.deviceName)} />
                                                ) : (
                                                    <FaStar style={{ fontSize: '24px', marginLeft: '8px', color: "yellow", stroke: "black", strokeWidth: "10px" }} onClick={() => cookicancel()} />
                                                )}


                                                {/*  */}
                                            </div>
                                            {expandedDevice === agentSetting.deviceName && editedPanel !== agentSetting.deviceName && (
                                                <>

                                                    <div style={{ marginBottom: "8px" }}>
                                                        <div style={{ fontWeight: "bold" }}>증상: </div>
                                                        {JSON.parse(agentSetting.agentSetting).증상
                                                            .filter((symptom: any) => Object.values(symptom)[0]) // Filter only true values
                                                            .map((symptom: any, index: any) => (
                                                                <span key={index}>{index > 0 ? ', ' : ''}{Object.keys(symptom)[0]}</span>
                                                            ))}
                                                    </div>
                                                    <div>
                                                        <div style={{ fontWeight: "bold" }}>진료실 정보: </div>
                                                        {JSON.parse(agentSetting.agentSetting).진료실
                                                            .filter((room: any) => Object.values(room)[0]) // Filter only true values
                                                            .map((room: any, index: any) => (
                                                                <span key={index}>{index > 0 ? ', ' : ''}{Object.keys(room)[0]}</span>
                                                            ))}
                                                    </div>
                                                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "8px" }}>
                                                        <Button type="primary" style={{ marginRight: "8px" }} onClick={() => QrprinttoggleModal(selectedClubInfo?.agentSeq === 1 ? "SELF-WAITING" : selectedClubInfo?.agentSeq === 3 ? "RECEPTION" : "")}>종이 QR 관리</Button>
                                                        

                                                        {agentSetting.deviceId.split(".")[0] === "tmp_device" && (
                                                            <div>
                                                                <Button type="primary" style={{ marginRight: "8px" }} onClick={() => handleEdit(agentSetting.deviceName, agentSetting.deviceId)}>
                                                                    수정
                                                                </Button>
                                                                <Button danger onClick={() => handledelete(agentSetting.deviceName, agentSetting.deviceId)}>
                                                                    삭제
                                                                </Button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </>
                                            )}
                                            {expandedDevice === agentSetting.deviceName && editedPanel === agentSetting.deviceName && (
                                                <>
                                                    {/* 증상 입력 부분 */}
                                                    <div style={{ marginBottom: "16px", display: "flex", justifyContent: "center" }}>
                                                        <div>
                                                            <div style={{ marginBottom: "8px", display: "flex", alignItems: "center" }}>
                                                                <div style={{ fontWeight: "bold", marginRight: "8px" }}>증상</div>
                                                            </div>
                                                            <div style={{ marginBottom: "8px", display: "flex", alignItems: "center" }}>
                                                                <Input
                                                                    placeholder="증상을 입력해주세요."
                                                                    style={{ flex: 1, marginRight: "8px", width: "215px" }}
                                                                    value={newSymptomInput}
                                                                    onChange={(e) => setNewSymptomInput(e.target.value)}
                                                                />
                                                                <Button
                                                                    type="primary"
                                                                    shape="circle"
                                                                    icon={<PlusOutlined />}
                                                                    onClick={() => QRhandleAddItem('증상', newSymptomInput)}
                                                                    style={{ marginRight: "8px", width: "40px", height: "40px" }}
                                                                />
                                                            </div>
                                                            {/* 증상 목록 */}
                                                            {agentSetting && JSON.parse(agentSetting.agentSetting).증상.map((symptom: any, index: any) => (
                                                                <div key={index} style={{ marginBottom: "8px", display: "flex", alignItems: "center" }}>
                                                                    <Checkbox
                                                                        style={{ marginRight: "8px" }}
                                                                        checked={(Object.values(symptom)[0] as boolean)}
                                                                        onChange={() => handleToggleSymptom(index, Object.keys(symptom)[0], Object.values(symptom)[0] as boolean)}
                                                                    />
                                                                    <div style={{ width: "200px" }}>
                                                                        {Object.keys(symptom)[0]}
                                                                    </div>
                                                                    <Button
                                                                        type="primary"
                                                                        shape="circle"
                                                                        icon={<MinusOutlined />}
                                                                        style={{ marginRight: "8px", width: "40px", height: "40px" }}
                                                                        onClick={() => handleDeleteItem('증상', index)}
                                                                    />
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>

                                                    {/* 진료실 입력 부분 */}
                                                    <div style={{ marginBottom: "16px", display: "flex", justifyContent: "center" }}>
                                                        <div>
                                                            <div style={{ marginBottom: "8px", display: "flex", alignItems: "center" }}>
                                                                <div style={{ fontWeight: "bold", marginRight: "8px" }}>진료실</div>
                                                            </div>
                                                            <div style={{ marginBottom: "8px", display: "flex", alignItems: "center" }}>
                                                                <Input
                                                                    placeholder="진료실을 입력해주세요."
                                                                    style={{ flex: 1, marginRight: "8px", width: "215px" }}
                                                                    value={newRoomInput}
                                                                    onChange={(e) => setNewRoomInput(e.target.value)}
                                                                />
                                                                <Button
                                                                    type="primary"
                                                                    shape="circle"
                                                                    icon={<PlusOutlined />}
                                                                    onClick={() => QRhandleAddItem('진료실', newRoomInput)}
                                                                    style={{ marginRight: "8px", width: "40px", height: "40px" }}
                                                                />
                                                            </div>
                                                            {/* 진료실 목록 */}
                                                            {agentSetting && JSON.parse(agentSetting.agentSetting).진료실.map((room: any, index: any) => (
                                                                <div key={index} style={{ marginBottom: "8px", display: "flex", alignItems: "center" }}>
                                                                    <Checkbox
                                                                        style={{ marginRight: "8px" }}
                                                                        checked={(Object.values(room)[0] as boolean)}
                                                                        onChange={() => handleToggleRoom(index, Object.keys(room)[0], Object.values(room)[0] as boolean)}
                                                                    />
                                                                    <div style={{ width: "200px" }}>
                                                                        {Object.keys(room)[0]}
                                                                    </div>

                                                                    <Button
                                                                        type="primary"
                                                                        shape="circle"
                                                                        icon={<MinusOutlined />}
                                                                        style={{ marginRight: "8px", width: "40px", height: "40px" }}
                                                                        onClick={() => handleDeleteItem('진료실', index)}
                                                                    />
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>

                                                    {/* 수정 완료 버튼 */}
                                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                                        <Button
                                                            type="primary"
                                                            style={{ width: "120px", height: "36px" }}
                                                            onClick={() => setEditedPanel(null)}
                                                        >
                                                            닫기
                                                        </Button>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                ))}

                        </Modal>
                    </div>
                )}



                {waitmodalOpen && iswaitModallocalname_emp && (

                    <Modal
                        title="신규 회원 정보 수정"
                        style={{ fontSize: "18px", borderRadius: "20px" }}
                        open={waitmodalOpen}

                        // onCancel={() => setWaitIsModalVisible(false)}
                        onCancel={waittoggleModal}
                        width={600}
                        footer={[
                            <div key="button-container" style={{ textAlign: "center" }}>
                                <Button
                                    key="confirm"
                                    type="primary"
                                    onClick={waithandledispose}
                                    style={{
                                        width: "120px",
                                        height: "56px",
                                        borderRadius: "20px",
                                        color: "#fff",
                                        background: "#2D5478",
                                        borderColor: "#2D5478",
                                    }}
                                >
                                    취소
                                </Button>
                                <Button
                                    key="confirm"
                                    type="primary"
                                    onClick={waithandleConfirm}
                                    style={{
                                        width: "120px",
                                        height: "56px",
                                        borderRadius: "20px",
                                        color: "#fff",
                                        background: "#2D5478",
                                        borderColor: "#2D5478",
                                    }}
                                    disabled={!newwaitname || !newwaitlocalname}
                                >
                                    저장
                                </Button>
                            </div>
                        ]}
                    >
                        <div style={{ marginBottom: "16px" }}>
                            <div style={{ display: "flex", marginBottom: "8px" }}>
                                <div style={{ marginRight: "8px", width: "300px" }}>이름</div>
                                <div style={{ marginRight: "8px", width: "300px" }}>차트번호</div>
                            </div>

                            <div style={{ display: "flex", marginBottom: "8px" }}>

                                <Input
                                    placeholder={selectwaitModalname}
                                    onChange={waitnamehandleInputChange}

                                    style={{ marginRight: "8px", width: "300px" }}
                                />
                                <Input
                                    placeholder="차트번호"
                                    // value={info.chartNumber}
                                    onChange={waitlocalnamehandleInputChange}
                                    style={{ marginRight: "8px", width: "300px" }}
                                />
                            </div>
                        </div>
                    </Modal>

                )}

                {waitmembermodalOpen && iswaitMemberModallocalname_emp && (

                    <Modal
                        title="기존 회원 정보 수정"
                        style={{ fontSize: "18px", borderRadius: "20px" }}
                        open={waitmembermodalOpen}

                        // onCancel={() => setWaitIsModalVisible(false)}
                        onCancel={waitmembertoggleModal}
                        width={800}
                        footer={[
                            <div key="button-container" style={{ textAlign: "center" }}>
                                <Button
                                    key="confirm"
                                    type="primary"
                                    onClick={waitmemberhandledispose}
                                    style={{
                                        width: "120px",
                                        height: "56px",
                                        borderRadius: "20px",
                                        color: "#fff",
                                        background: "#2D5478",
                                        borderColor: "#2D5478",
                                    }}

                                >
                                    취소
                                </Button>
                                <Button
                                    key="confirm"
                                    type="primary"
                                    onClick={waitmemberhandleConfirm}
                                    style={{
                                        width: "120px",
                                        height: "56px",
                                        borderRadius: "20px",
                                        color: "#fff",
                                        background: "#2D5478",
                                        borderColor: "#2D5478",
                                    }}
                                    disabled={!selectwaitmemberModalname || !memberwaitlocalname}
                                >
                                    저장
                                </Button>
                            </div>
                        ]}
                    >
                        <div style={{ marginBottom: "16px" }}>
                            <div style={{ display: "flex", marginBottom: "8px" }}>
                                <div style={{ marginRight: "8px", width: "300px" }}>이름</div>
                                <div style={{ marginRight: "8px", width: "300px" }}>차트번호</div>
                            </div>

                            <div style={{ display: "flex", marginBottom: "8px" }}>

                                <Input
                                    placeholder="이름"
                                    defaultValue={selectwaitmemberModalname}
                                    onChange={waitnamehandleInputChange}
                                    readOnly
                                    style={{ marginRight: "8px", width: "300px" }}
                                />
                                <Input
                                    placeholder="차트번호"
                                    // value={info.chartNumber}
                                    onChange={memberwaitlocalnamehandleInputChange}
                                    style={{ marginRight: "8px", width: "300px" }}
                                />
                            </div>
                        </div>
                    </Modal>

                )}
                {qrprintmodalOpen && (

                    <Modal

                        title="QR 관리"
                        style={{ fontSize: "18px", borderRadius: "20px" }}
                        open={qrprintmodalOpen}

                        // onCancel={() => setWaitIsModalVisible(false)}
                        onCancel={QrprinttoggleModal}
                        width={800}
                        footer={[
                            <div key="button-container" style={{ textAlign: "center" }}>
                                <Button
                                    type="primary"
                                    style={{ marginRight: "8px" }}
                                    onClick={() => qrcreate(selectedClubInfo?.agentSeq === 1 ? "SELF-WAITING" : selectedClubInfo?.agentSeq === 3 ? "RECEPTION" : "")}
                                >
                                    {qrdata === "" ? "QR 생성" : "마감일 수정"}
                                </Button>

                                <Button type="primary" style={{ marginRight: "8px", display: qrdata === "" ? "none" : "", }} onClick={() => qrprint()}>인쇄</Button>
                                <Button danger style={{ marginRight: "8px", display: qrdata === "" ? "none" : "", }} onClick={() => QRhandledelete()}>삭제</Button>
                            </div>
                        ]}
                    >
                        <div style={{ marginBottom: "16px" }}>



                            <div ref={qrRef} onClick={handleQRClick} style={{ cursor: 'pointer' }}>
                                <QRCode value={qrdata} size={500} />
                            </div>
                            <div style={{ display: "flex", marginBottom: "8px" }}>
                                <div style={{ marginRight: "8px", width: "300px" }}>마감일자</div>
                                {/* 2024-05-14T17:15:00 */}
                            </div>
                            <div style={{ display: "flex", marginBottom: "8px" }}>
                                <DatePicker
                                    // placeholder={lastdate+""}
                                    clearIcon
                                    placeholder="마감일을 선택해주세요"
                                    value={dayjs(lastdate)}
                                    onChange={handleLastDateChange}
                                    style={{ marginRight: "8px", width: "150px" }}
                                    
                                />

                                <TimePicker
                                    
                                    clearIcon
                                    style={{ marginRight: "8px", width: "200px" }}
                                    value={dayjs(Qrlasttimetime, 'HH:mm')} // 시간
                                    format="HH:mm"
                                    onChange={handleTimeChange}
                                     popupClassName="custom-timepicker-popup"
                                    changeOnBlur
                                />

                            </div>
                        </div>
                    </Modal>

                )}


                <div
                    style={{
                        width: width <= 1600 ? "60%" : "50%",
                        height: width <= 1600 ? "500px" : "1000px",
                        // backgroundColor:"black",
                        overflowY: "auto",
                    }}
                >

                    <div
                        style={{
                            width: "100%",
                            // height: "50vh",
                        }}
                    >
                        {/* 대기테이블 */}
                        <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                            <thead>

                                <tr>

                                    {columns.map((col, index) => (
                                        <th key={col.key+index} style={{ textAlign: 'center', border: '1px solid black', width: col.width }}>{col.title}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {waitingdata.map((record, col1) => (
                                    <tr
                                        key={record.key+col1}
                                        style={{ border: '1px solid black' }}
                                    // onClick={() => tablehandleRowClick(record,col)}
                                    >
                                        {columns.map((col, index, recode) => (
                                            <td key={col.key+index} style={{ textAlign: 'center', border: '1px solid black' }}>
                                                {col.dataIndex === '진료실' ? (
                                                    <span onClick={() => tablehandleRowClick(record, col)} style={{ cursor: 'pointer' }}>
                                                        <div>
                                                            <div>{waitingdata[col1]?.희망진료실}</div>
                                                            <Select

                                                                style={{ width: "100%" }}
                                                                onChange={(value) => handleSelectChange(record, value)}
                                                                value={record[col.dataIndex] ? record[col.dataIndex] : "진료실 선택"}
                                                            >
                                                                {selectrooms.map((room: any, index: any) => (
                                                                    <Option key={index} value={room}>
                                                                        {room}
                                                                    </Option>
                                                                ))}

                                                            </Select>
                                                        </div>
                                                    </span>

                                                ) : col.dataIndex === '차트번호' ? (
                                                    <div>
                                                        <span onClick={() => handleChartNumberClick(record, col)} style={{ cursor: 'pointer', width: "100%", height: "40px", display: 'flex', justifyContent: 'center', alignItems: 'center', boxSizing: 'border-box', paddingTop: "15px", paddingBottom: "15px" }}>
                                                            {record[col.dataIndex] ? record[col.dataIndex] : ""}
                                                        </span>

                                                        <span onClick={() => handleQcordClick(record, col)} style={{
                                                            cursor: 'pointer', width: "100%", height: "40px", justifyContent: 'center', alignItems: 'center', boxSizing: 'border-box', paddingTop: "15px", paddingBottom: "15px", display: (() => {
                                                                const symptom = record.내원증상.trim();
                                                                const parts = symptom.split(',');
                                                                let hasQNumber = false; // "Q"로 시작하고 뒤에 12자리 숫자가 오는 부분이 있는지 여부를 나타내는 플래그
                                                                parts.forEach((part: any) => {
                                                                    if (/^Q\d{12}$/.test(part.trim())) {
                                                                        hasQNumber = true;
                                                                    }
                                                                });
                                                                return hasQNumber ? 'flex' : 'none';
                                                            })()
                                                        }}>
                                                            {(() => {
                                                                const symptom = record.내원증상.trim();
                                                                const parts = symptom.split(',');
                                                                let result = '';
                                                                parts.forEach((part: any) => {
                                                                    if (/^Q\d{12}$/.test(part.trim())) {
                                                                        result += part.trim() + ', ';
                                                                    }
                                                                });
                                                                return result.slice(0, -2);
                                                            })()}
                                                        </span>
                                                    </div>

                                                ) : col.dataIndex === '회원명' ? (
                                                    <span onClick={() => handlememberClick(record, col)} style={{ cursor: 'pointer', width: "100%", height: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center', boxSizing: 'border-box', paddingTop: "15px", paddingBottom: "15px" }}>
                                                        {record[col.dataIndex] ? record[col.dataIndex] : "　"}
                                                        {/* {record[col.dataIndex]} */}
                                                    </span>
                                                ) : col.dataIndex === '내원증상' ? (
                                                    <span style={{ cursor: 'pointer', width: "100%", height: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center', boxSizing: 'border-box', paddingTop: "15px", paddingBottom: "15px" }}>
                                                        {(() => {
                                                            const symptom = record.내원증상.trim();
                                                            const parts = symptom.split(',');
                                                            let result = '';
                                                            parts.forEach((part: any) => {
                                                                if (!/^Q\d{12}$/.test(part.trim())) {
                                                                    result += part.trim() + ', ';
                                                                }
                                                            });
                                                            return result.slice(0, -2);
                                                        })()}
                                                    </span>


                                                ) : col.dataIndex === '수진자확인' ? (
                                                    <span onClick={() => handlejuminNumberClick(record, col)} style={{ cursor: 'pointer', width: "100%", height: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center', boxSizing: 'border-box', paddingTop: "15px", paddingBottom: "15px" }}>
                                                        {record[col.dataIndex] ? record[col.dataIndex] : "　"}
                                                        {/* {record[col.dataIndex]} */}
                                                    </span>
                                                ) : col.dataIndex === '가족' ? (
                                                    <span onClick={() => handleFamilyClick(record, col)} style={{ cursor: 'pointer' }}>
                                                        <div>
                                                            {record[col.dataIndex] && record[col.dataIndex].length > 0 ? (
                                                                record[col.dataIndex].map((familyMember: any, index: any) => (
                                                                    <div key={index}>
                                                                        {Object.entries(familyMember).map(([key, value]) => {
                                                                            if (key === '이름' && value) {
                                                                                const gender = familyMember['성별'] === '남' ? 'M' : familyMember['성별'] === '여' ? 'F' : 'U';
                                                                                const birthDate = familyMember['생년월일'];
                                                                                const relationship = familyMember['관계'];
                                                                                const age = new Date().getFullYear() - new Date(birthDate).getFullYear();
                                                                                return (
                                                                                    <div key={key}>{`${relationship} ${value || '　'} ${gender}/${age}`}</div>
                                                                                );
                                                                            }
                                                                            return null; // null 반환하여 아무것도 출력하지 않음
                                                                        })}
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <div>　</div>
                                                            )}
                                                        </div>
                                                    </span>
                                                ) : (
                                                    <div onClick={() => tablehandleRowClick(record, col)} style={{ lineHeight: '35px', cursor: 'pointer', width: "100%", height: "100%", display: 'block', boxSizing: 'border-box' }}>
                                                        {record[col.dataIndex] ? record[col.dataIndex] : "　"}
                                                    </div>

                                                )}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div
                        style={{
                            textAlign: "left",
                            padding: "20px",
                            fontSize: "25px",
                        }}
                    >

                    </div>
                    <div
                        style={{
                            width: "100%",
                            // height: "500px",
                        }}
                    >
                        <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                            <thead>

                                <tr>

                                    {columns1.map((col, index) => (
                                        <th key={col.key} style={{ textAlign: 'center', border: '1px solid black', width: col.width }}>{col.title}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {waitingdata1.map((record, col) => (
                                    <tr
                                        key={record.key}
                                        style={{ border: '1px solid black' }}
                                        onClick={() => tablehandleRowClick(record, col)}
                                    >
                                        {columns1.map((col) => (
                                            <td key={col.key} style={{ textAlign: 'center', border: '1px solid black' }}>
                                                {col.dataIndex === '진료실' ? (
                                                    <div>
                                                        <div>{record[col.dataIndex].split("@")[0]}</div>

                                                    </div>
                                                ) : col.dataIndex === '텍스트' ? (
                                                    <textarea
                                                        style={{ width: '100%' }}
                                                        defaultValue={record[col.dataIndex]}
                                                    />
                                                ) : col.dataIndex === '가족' ? (
                                                    <div>
                                                        {record[col.dataIndex] && record[col.dataIndex].map((familyMember: any, familyIndex: any) => (
                                                            <div key={familyIndex}>
                                                                {Object.entries(familyMember).map(([key, value]) => {
                                                                    if (key === '이름' && value) {
                                                                        const gender = familyMember['성별'] === '남' ? 'M' : familyMember['성별'] === '여' ? 'F' : 'U';
                                                                        const birthDate = familyMember['생년월일'];
                                                                        const relationship = familyMember['관계'];
                                                                        const age = new Date().getFullYear() - new Date(birthDate).getFullYear();
                                                                        return (
                                                                            <div key={key}>{`${relationship} ${value} ${gender}/${age}`}</div>
                                                                        );
                                                                    }
                                                                    return null;
                                                                })}
                                                            </div>
                                                        ))}
                                                    </div>
                                                ) : (
                                                    record[col.dataIndex]
                                                )}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div
                    style={{
                        width: width <= 1600 ? "40%" : "50%",
                        height: "100%",
                        marginLeft: "20px",
                    }}
                >
                    <div
                        style={{
                            display: "flex",

                            width: width <= 1600 ? "100%" : "100%",
                            height: "70px",
                            border: "1px solid #123758",
                            borderRadius: "10px",

                            marginBottom: "30px",
                        }}
                    >
                        <div
                            style={{
                                fontFamily: "Noto Sans KR",
                                fontSize: "1vw",
                                fontWeight: "30px",
                                width: "30%",
                                lineHeight: "24px",
                                letterSpacing: "-0.01em",
                                textAlign: "left",
                                marginLeft: "30px",
                                marginTop: "20px",
                            }}
                        >
                            {firstElement}
                        </div>

                        <div
                            style={{
                                fontFamily: "Noto Sans KR",
                                fontSize: "1vw",
                                width: "50%",
                                lineHeight: "24spx",
                                letterSpacing: "-0.01em",
                                textAlign: "left",
                                marginTop: "20px",
                            }}
                        >
                            {fourthElement}
                        </div>

                        <div
                            style={{
                                fontFamily: "Noto Sans KR",
                                fontSize: "1vw",
                                width: "50%",
                                lineHeight: "24spx",
                                letterSpacing: "-0.01em",
                                textAlign: "left",
                                // marginLeft: "100px",
                                marginTop: "20px",
                            }}
                        >
                            {secondElement}
                        </div>

                        <div
                            style={{
                                fontFamily: "Noto Sans KR",
                                fontSize: "1vw",
                                width: "50%",
                                lineHeight: "24spx",
                                letterSpacing: "-0.01em",
                                textAlign: "left",
                                marginTop: "20px",
                            }}
                        >
                            {thirdElement}
                        </div>

                        <button
                            style={{
                                cursor: "pointer",
                                width: "150px",
                                height: "40px",
                                margin: "15px",
                                borderRadius: "10px",
                                backgroundColor: "#2D5478",
                                border: "1px solid #2D5478", // Set border color and thickness
                                color: "white",
                            }}
                            onClick={onWaitButtonClick}
                        >
                            대기완료
                        </button>
                    </div>
                    <div
                        style={{
                            width: "100%",
                            height: "100px",
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            marginBottom: "10px",
                            flexDirection: 'column',
                        }}
                    >
                        <div style={{ width: '100%', height: '50px', display: 'flex', alignItems: 'left' }}>


                            <div style={{ fontSize: width <= 1600 ? "15px" : "25px", height: '50px', overflowY: 'auto', marginLeft: "30px" }}>


                                진료과 :
                                {!isOn ? (
                                    agentsettingdeviceName.map((deviceName: string, index: number) => (
                                        <label key={index} style={{ marginRight: '10px', marginLeft: '30px' }}>
                                            <input
                                                type="radio"
                                                value={deviceName}
                                                checked={selectedDeviceName ? selectedDeviceName === deviceName : false}
                                                onChange={handleAgentSettingChange}
                                                style={{ marginRight: '5px', cursor: 'pointer' }}
                                            />
                                            {deviceName}
                                        </label>
                                    ))
                                ) : (




                                    <Select
                                        onChange={handleAgentSettingSelectChange}
                                        value={selectedDeviceNameRef.current}
                                        style={{ width: '200px', fontSize: '20px', cursor: "pointer", marginLeft: '30px' }}
                                    >
                                        {agentsettingdeviceName.map((deviceName: string, index: number) => (
                                            <Option key={index} value={deviceName} style={{ fontSize: '20px' }}>
                                                {deviceName}
                                            </Option>
                                        ))}
                                    </Select>
                                )}


                            </div>

                        </div>
                        <div style={{ width: '100%', height: '50px', display: 'flex', alignItems: 'center' }}>
                            <div>
                                <Button
                                    onClick={handleLeftButtonClick}
                                    style={{
                                        fontSize: width <= 1600 ? "10px" : "20px",
                                        width: width <= 1600 ? "35px" : "50px",
                                        height: width <= 1600 ? "35px" : "50px",
                                        marginLeft: "5px",
                                    }}
                                >
                                    ◀
                                </Button>
                                <Button
                                    onClick={handleRightButtonClick}
                                    style={{
                                        fontSize: width <= 1600 ? "10px" : "20px",
                                        width: width <= 1600 ? "35px" : "50px",
                                        height: width <= 1600 ? "35px" : "50px",
                                        marginLeft: "5px",
                                    }}
                                >
                                    ▶
                                </Button>

                            </div>
                            <div style={{ fontSize: "25px", marginLeft: "30px", display: 'flex', alignItems: 'center' }}>
                                대기({beforreceiptcount})
                                완료({beforreceiptcount1})
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <Button onClick={toggleButton}>
                                    {isOn ? 'R' : 'S'}
                                </Button>
                                <div style={{ display: 'flex', alignItems: 'center', marginLeft: "10px" }}>
                                    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                        <img
                                            src="asset/img/pqr.png"
                                            alt="QR Icon"
                                            onClick={PQrtoggleModal}
                                            style={{
                                                width: width <= 1600 ? "20px" : "40px",
                                                height: width <= 1600 ? "20px" : "40px",
                                                cursor: "pointer",

                                            }}
                                        />
                                        <span style={{ fontSize: '15px' }}>종이</span>
                                    </div>

                                    {/* <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                        <img
                                            src="asset/img/qqr.png"
                                            alt="QR Icon"
                                            onClick={QQrtoggleModal}
                                            style={{
                                                width: width <= 1600 ? "20px" : "40px",
                                                height: width <= 1600 ? "20px" : "40px",
                                                cursor: "pointer",

                                            }}
                                        />
                                        <span style={{ fontSize: '15px' }}>서식</span>
                                    </div> */}
                                </div>
                            </div>


                            <div
                                style={{
                                    textAlign: "left",
                                    fontSize: "25px",
                                    marginLeft: "auto",
                                    marginRight: "20px" // 오른쪽 여백
                                }}
                            >

                                <img
                                    src="asset/img/refresh.png"
                                    alt="Refresh Icon"
                                    onClick={handleRotate}

                                    className={isRotating ? "rotate" : ""}
                                    style={{
                                        width: width <= 1600 ? "30px" : "50px",
                                        height: width <= 1600 ? "30px" : "50px",

                                        cursor: "pointer",
                                        marginLeft: "10px",
                                        transition: "transform 1s linear",
                                        transform: isRotating ? "rotate(1500deg)" : "rotate(0deg)"
                                        // transform: isRotating ? "rotate(900deg)" : "rotate(0deg)"

                                    }}
                                />
                            </div>
                        </div>

                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            height: width <= 1600 ? "500px" : "910px",
                        }}
                    >
                        <div
                            style={{
                                flex: 1,
                                borderStyle: "solid",
                                border: "1px solid gray",
                                overflowX: "auto",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    height: "100%",
                                }}
                            >
                                <div
                                    style={{
                                        flex: "5%",
                                        fontSize: width <= 1600 ? "20px" : "25px",
                                        textAlign: "center",
                                        margin: "10px",
                                        borderBottom: "1px solid #000000", // 아래 선 스타일 추가
                                    }}
                                >
                                    {display1}
                                </div>
                                <div style={{ flex: "95%" }}>
                                    <div
                                        style={{
                                            width: "100%",
                                        }}
                                    >

                                        {waitingtabledataArray1.length > 0 && (
                                            <Table
                                                dataSource={waitingtabledataArray1}
                                                columns={viewcolumns.map((col, index) => ({
                                                    ...col,
                                                    ellipsis: false,
                                                    align: index === 1 ? "left" : "center",
                                                    style: {
                                                        padding: 0, // 각 셀의 padding을 0으로 설정
                                                    },
                                                    render: (text) => (
                                                        <span
                                                            style={{
                                                                fontSize:
                                                                    width <= 1600 ? "15px" : "20px",
                                                            }}
                                                        >
                                                            {text}
                                                        </span>
                                                    ),
                                                }))}
                                                pagination={false}
                                                bordered={false}
                                                showHeader={false}
                                                scroll={{ y: width <= 1600 ? 600 : 910 }}
                                                style={{
                                                    border: "none",
                                                    width: "100%",
                                                    backgroundColor: "transparent",
                                                }}
                                                onRow={(record) => ({
                                                    onClick: () =>
                                                        tableviewhandleRowClick(record),
                                                })}
                                                rowKey={(record) => record.key}
                                                rowClassName={undefined}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            style={{
                                flex: 1,
                                borderStyle: "solid",
                                border: "1px solid gray",
                                overflowX: "auto",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    height: "100%",
                                }}
                            >
                                <div
                                    style={{
                                        flex: "5%",
                                        fontSize: width <= 1600 ? "20px" : "25px",
                                        textAlign: "center",
                                        margin: "10px",
                                        borderBottom: "1px solid #000000", // 아래 선 스타일 추가
                                    }}
                                >
                                    {display2}
                                </div>
                                <div style={{ flex: "95%" }}>
                                    <div
                                        style={{
                                            width: "100%",
                                        }}
                                    >
                                        {waitingtabledataArray2.length > 0 && (
                                            <Table
                                                dataSource={waitingtabledataArray2}
                                                columns={viewcolumns.map((col, index) => ({
                                                    ...col,
                                                    ellipsis: false,
                                                    align: index === 1 ? "left" : "center",
                                                    render: (text) => (
                                                        <span
                                                            style={{
                                                                fontSize:
                                                                    width <= 1600 ? "15px" : "20px",
                                                            }}
                                                        >
                                                            {text}
                                                        </span>
                                                    ),
                                                }))}
                                                pagination={false}
                                                bordered={false}
                                                showHeader={false}
                                                scroll={{ y: width <= 1600 ? 600 : 910 }}
                                                style={{
                                                    border: "none",
                                                    width: "100%",
                                                    backgroundColor: "transparent",
                                                }}
                                                onRow={(record) => ({
                                                    onClick: () =>
                                                        tableviewhandleRowClick(record),
                                                })}
                                                rowKey={(record) => record.key}
                                                rowClassName={undefined}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            style={{
                                flex: 1,
                                borderStyle: "solid",
                                border: "1px solid gray",
                                overflowX: "auto",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    height: "100%",
                                }}
                            >
                                <div
                                    style={{
                                        flex: "5%",
                                        fontSize: width <= 1600 ? "20px" : "25px",
                                        textAlign: "center",
                                        margin: "5px",
                                        borderBottom: "1px solid #000000", // 아래 선 스타일 추가
                                    }}
                                >
                                    {display3}
                                </div>
                                <div style={{ flex: "95%" }}>
                                    <div
                                        style={{
                                            width: "100%",
                                        }}
                                    >

                                        {waitingtabledataArray3.length > 0 && (
                                            <Table
                                                dataSource={waitingtabledataArray3}
                                                columns={viewcolumns.map((col, index) => ({
                                                    ...col,
                                                    ellipsis: false,
                                                    align: index === 1 ? "left" : "center",
                                                    render: (text) => (
                                                        <span
                                                            style={{
                                                                fontSize:
                                                                    width <= 1600 ? "15px" : "20px",
                                                            }}
                                                        >
                                                            {text}
                                                        </span>
                                                    ),
                                                }))}
                                                pagination={false}
                                                bordered={false}
                                                showHeader={false}
                                                scroll={{ y: width <= 1600 ? 600 : 910 }}
                                                style={{
                                                    border: "none",
                                                    width: "100%",
                                                    backgroundColor: "transparent",
                                                }}
                                                onRow={(record) => ({
                                                    onClick: () =>
                                                        tableviewhandleRowClick(record),
                                                })}
                                                rowKey={(record) => record.key}
                                                rowClassName={undefined}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );

};

export default ReceptionWaitListView;